{
  "formatVersion": 1,
  "authority": "SCRUM-427-D11",
  "prototypeCommit": "56d4bd6",
  "sourceSha256": "9fdbae64e351fda0bc6591edabe5e1c59edfbe6d99e15168a015df8330d62210",
  "bundles": [
    {
      "id": "move",
      "title": "Moving home",
      "summary": "Notice dates, services, address changes and getting your deposit back.",
      "sections": [
        {
          "id": "before",
          "title": "Before the move",
          "summary": "Choose the arrangements with a date you need to remember.",
          "tasks": [
            {
              "id": "notice",
              "title": "Give notice on your current tenancy",
              "source": "provider",
              "hint": "Only if you rent. Use your agreement and the rules that apply to your tenancy.",
              "optional": true
            },
            {
              "id": "removals",
              "title": "Removals or van booking",
              "source": "appointment",
              "hint": "Use your confirmed booking date.",
              "optional": true
            },
            {
              "id": "redirect",
              "title": "Arrange mail redirection",
              "source": "plan",
              "hint": "Choose when to apply, allowing for the postal service's lead time.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange home insurance for the new address",
              "source": "plan",
              "hint": "If needed, arrange cover before the start date agreed with your insurer.",
              "optional": true
            }
          ]
        },
        {
          "id": "leave",
          "title": "Leaving your old home",
          "summary": "Close accounts and keep the readings needed for your final bills.",
          "tasks": [
            {
              "id": "old-energy",
              "title": "Notify your old energy supplier",
              "source": "plan",
              "hint": "Give your move-out date using your supplier's process.",
              "optional": true
            },
            {
              "id": "old-water",
              "title": "Notify your old water supplier",
              "source": "plan",
              "hint": "If you hold a separate water account.",
              "optional": true
            },
            {
              "id": "old-internet",
              "title": "Arrange your internet transfer or cancellation",
              "source": "plan",
              "hint": "Allow for your provider's notice period. Choose the arrangement you actually need.",
              "optional": true
            },
            {
              "id": "final-energy",
              "title": "Record final energy meter readings",
              "source": "plan",
              "hint": "Choose your handover date. Keep the readings outside this app.",
              "optional": true
            },
            {
              "id": "final-water",
              "title": "Record the final water meter reading",
              "source": "plan",
              "hint": "Only if your property has a water meter you need to read.",
              "optional": true
            }
          ]
        },
        {
          "id": "arrive",
          "title": "At your new home",
          "summary": "Your handover and service arrangements.",
          "tasks": [
            {
              "id": "keys",
              "title": "New-home key handover",
              "source": "appointment",
              "hint": "Use the agreed handover date.",
              "optional": false
            },
            {
              "id": "new-energy",
              "title": "Set up the new energy account",
              "source": "plan",
              "hint": "If you are responsible for the supply.",
              "optional": true
            },
            {
              "id": "new-water",
              "title": "Set up the new water account",
              "source": "plan",
              "hint": "If a separate account is needed.",
              "optional": true
            },
            {
              "id": "new-internet",
              "title": "Internet installation appointment",
              "source": "appointment",
              "hint": "Only if an installation visit is booked.",
              "optional": true
            },
            {
              "id": "inventory",
              "title": "Return the checked inventory or condition report",
              "source": "provider",
              "hint": "If required, use the deadline in your handover instructions.",
              "optional": true
            }
          ]
        },
        {
          "id": "details",
          "title": "Update your address",
          "summary": "Choose the organisations you use. Each can have its own reminder.",
          "tasks": [
            {
              "id": "bank",
              "title": "Update your bank address",
              "source": "plan",
              "hint": "Add another reminder if a different bank needs a different date.",
              "optional": true
            },
            {
              "id": "employer",
              "title": "Update your employer's address records",
              "source": "plan",
              "hint": "If you need to update payroll or contact details.",
              "optional": true
            },
            {
              "id": "motor-cover",
              "title": "Update your motor-insurance address",
              "source": "plan",
              "hint": "Check with your insurer when the change needs to take effect.",
              "optional": true
            },
            {
              "id": "school",
              "title": "Update your school or childcare contact address",
              "source": "plan",
              "hint": "Only if relevant to your arrangements.",
              "optional": true
            },
            {
              "id": "pet-details",
              "title": "Update your pet's microchip contact details",
              "source": "plan",
              "hint": "Use the database holding your pet's registration.",
              "optional": true
            },
            {
              "id": "local-tax",
              "title": "Tell your council or rates office about the move",
              "source": "provider",
              "hint": "Council Tax in England, Scotland and Wales; domestic rates in Northern Ireland. Use your authority's process.",
              "optional": true
            },
            {
              "id": "driving",
              "title": "Update your driving-licence address",
              "source": "provider",
              "hint": "Choose the DVLA route in Great Britain or the DVA route in Northern Ireland.",
              "optional": true
            },
            {
              "id": "v5c",
              "title": "Update the vehicle log book address",
              "source": "provider",
              "hint": "This is separate from updating your driving licence.",
              "optional": true
            },
            {
              "id": "voter",
              "title": "Update your electoral registration",
              "source": "provider",
              "hint": "If eligible; use the process for your new address.",
              "optional": true
            },
            {
              "id": "tv",
              "title": "Update the address on your TV Licence",
              "source": "plan",
              "hint": "Only if you have one that needs updating.",
              "optional": true
            },
            {
              "id": "hmrc",
              "title": "Update your address with HMRC",
              "source": "plan",
              "hint": "If relevant to your tax records.",
              "optional": true
            },
            {
              "id": "benefits",
              "title": "Update your address with your benefit provider",
              "source": "plan",
              "hint": "Only if you receive a benefit that needs a separate update.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the move",
          "summary": "Outstanding money and equipment with a return deadline.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Follow up your tenancy-deposit return",
              "source": "provider",
              "hint": "Use the expected return date agreed through your tenancy process.",
              "optional": true
            },
            {
              "id": "return-router",
              "title": "Return your old provider's router or equipment",
              "source": "provider",
              "hint": "Use the return deadline from your provider.",
              "optional": true
            }
          ]
        }
      ],
      "market": "GB",
      "sources": [
        ["Moving and vehicle records", "https://www.gov.uk/tell-dvla-changed-address"],
        [
          "Northern Ireland rates",
          "https://www.nidirect.gov.uk/articles/make-changes-your-rate-account"
        ]
      ],
      "count": 28,
      "variant": "default"
    },
    {
      "id": "holiday",
      "title": "Going on a booked holiday",
      "summary": "Payment deadlines, travel paperwork and arrangements before you leave.",
      "sections": [
        {
          "id": "essentials",
          "title": "Before you travel",
          "summary": "Use your booking and destination requirements.",
          "tasks": [
            {
              "id": "documents",
              "title": "Check passport validity and entry requirements",
              "source": "plan",
              "hint": "Choose a date early enough to act. Requirements depend on your destination and circumstances.",
              "optional": false
            },
            {
              "id": "document-apply",
              "title": "Submit the visa or travel-authorisation application",
              "source": "provider",
              "hint": "Only if required. Check the relevant authority's current process and processing time.",
              "optional": true
            },
            {
              "id": "balance",
              "title": "Pay the holiday booking balance",
              "source": "provider",
              "hint": "Use the due date in your booking. Skip if already paid.",
              "optional": true
            },
            {
              "id": "insurance",
              "title": "Arrange travel insurance",
              "source": "plan",
              "hint": "If you need cover, check when it needs to begin.",
              "optional": true
            }
          ]
        },
        {
          "id": "departure",
          "title": "Bookings to remember",
          "summary": "Only include bookings or deadlines you actually have.",
          "tasks": [
            {
              "id": "checkin",
              "title": "Complete airline online check-in",
              "source": "provider",
              "hint": "Use your airline's check-in window.",
              "optional": true
            },
            {
              "id": "pet-care",
              "title": "Confirm your pet's boarding or sitter booking",
              "source": "plan",
              "hint": "If your pet is staying behind; use the provider's confirmation deadline if supplied.",
              "optional": true
            },
            {
              "id": "parking",
              "title": "Pay a travel or airport-parking booking balance",
              "source": "provider",
              "hint": "Only if your existing booking has an outstanding payment.",
              "optional": true
            },
            {
              "id": "return-vehicle",
              "title": "Return the hire car",
              "source": "appointment",
              "hint": "Use the return date and time in your rental agreement.",
              "optional": true
            }
          ]
        }
      ],
      "market": "GB",
      "sources": [],
      "count": 8,
      "variant": "default"
    },
    {
      "id": "pet",
      "title": "Your pet's care dates",
      "summary": "Vet dates, treatments, insurance and boarding requirements in one place.",
      "sections": [
        {
          "id": "care",
          "title": "Health and appointments",
          "summary": "Use dates already given by your vet or provider.",
          "tasks": [
            {
              "id": "vaccination",
              "title": "Pet vaccination due",
              "source": "care",
              "hint": "Use the next date given by your vet.",
              "optional": false
            },
            {
              "id": "flea",
              "title": "Pet flea treatment due",
              "source": "care",
              "hint": "Use the next treatment date given by your vet.",
              "optional": true
            },
            {
              "id": "worm",
              "title": "Pet worm treatment due",
              "source": "care",
              "hint": "Use the next treatment date given by your vet.",
              "optional": true
            },
            {
              "id": "medicine",
              "title": "Collect your pet's prescribed medicine",
              "source": "care",
              "hint": "Use the collection or refill date agreed with your vet.",
              "optional": true
            },
            {
              "id": "groom",
              "title": "Pet grooming appointment",
              "source": "appointment",
              "hint": "Use your confirmed booking.",
              "optional": true
            }
          ]
        },
        {
          "id": "records",
          "title": "Insurance and records",
          "summary": "Choose only the records that need attention.",
          "tasks": [
            {
              "id": "insurance",
              "title": "Pet-insurance renewal",
              "source": "provider",
              "hint": "Use the renewal date on your policy.",
              "optional": true
            },
            {
              "id": "chip-update",
              "title": "Update your pet's microchip details",
              "source": "plan",
              "hint": "Useful after a move, new phone number or change of keeper.",
              "optional": true
            },
            {
              "id": "registration-apply",
              "title": "Register or license your pet if required",
              "source": "provider",
              "hint": "Check the rules for your UK nation and animal; do not assume every pet needs a licence.",
              "optional": true
            },
            {
              "id": "licence-renew",
              "title": "Renew an expiring pet licence",
              "source": "provider",
              "hint": "Only if your actual licence expires; skip lifetime registration.",
              "optional": true
            }
          ]
        },
        {
          "id": "away",
          "title": "Before boarding",
          "summary": "Requirements tied to a stay you have booked.",
          "tasks": [
            {
              "id": "requirements",
              "title": "Send the boarding provider's required records",
              "source": "provider",
              "hint": "Use their deadline and send records directly to the provider; there are no uploads here.",
              "optional": true
            },
            {
              "id": "boarding",
              "title": "Pet boarding drop-off",
              "source": "appointment",
              "hint": "Use the booking you have made.",
              "optional": true
            },
            {
              "id": "collect",
              "title": "Pet boarding collection",
              "source": "appointment",
              "hint": "Use the agreed collection date.",
              "optional": true
            }
          ]
        }
      ],
      "market": "GB",
      "sources": [["Microchip details", "https://www.gov.uk/get-your-dog-cat-microchipped"]],
      "count": 12,
      "variant": "default"
    },
    {
      "id": "baby",
      "title": "New-baby paperwork and appointments",
      "summary": "Registration, parental leave, support applications and booked appointments.",
      "sections": [
        {
          "id": "leave",
          "title": "Leave and support",
          "summary": "Your own requests and applications, where applicable.",
          "tasks": [
            {
              "id": "leave-request",
              "title": "Submit your parental-leave request",
              "source": "provider",
              "hint": "Use your employer's process and the dates that apply to you.",
              "optional": true
            },
            {
              "id": "support-apply",
              "title": "Submit a family-benefit or support application",
              "source": "provider",
              "hint": "Only after checking eligibility and the actual application deadline.",
              "optional": true
            },
            {
              "id": "return-work",
              "title": "Confirm your return-to-work date",
              "source": "provider",
              "hint": "Use the notice arrangements agreed with your employer.",
              "optional": true
            }
          ]
        },
        {
          "id": "paperwork",
          "title": "Registration and cover",
          "summary": "Follow the process that applies where the birth is registered.",
          "tasks": [
            {
              "id": "register",
              "title": "Complete the applicable birth-registration step",
              "source": "provider",
              "hint": "Use the registration authority where the birth happened; UK nations have different processes.",
              "optional": false
            },
            {
              "id": "certificate",
              "title": "Order a birth certificate if needed",
              "source": "plan",
              "hint": "Only if a separate request is needed. No certificate details or uploads are stored here.",
              "optional": true
            },
            {
              "id": "health-registration",
              "title": "Complete health-service or health-cover enrolment",
              "source": "provider",
              "hint": "If needed, use your health service or insurer's actual enrolment deadline.",
              "optional": true
            },
            {
              "id": "passport",
              "title": "Submit a passport application for planned travel",
              "source": "plan",
              "hint": "Only if needed for travel. Check the issuing authority's process.",
              "optional": true
            }
          ]
        },
        {
          "id": "appointments",
          "title": "Appointments and childcare",
          "summary": "Your reminders for dates already arranged.",
          "tasks": [
            {
              "id": "appointment",
              "title": "Health appointment",
              "source": "care",
              "hint": "Use the confirmed date from your practitioner; no care schedule is inferred.",
              "optional": true
            },
            {
              "id": "place",
              "title": "Respond to a childcare place offer",
              "source": "provider",
              "hint": "Use the acceptance deadline in the offer.",
              "optional": true
            }
          ]
        }
      ],
      "market": "GB",
      "sources": [["Birth registration", "https://www.gov.uk/register-birth"]],
      "count": 9,
      "variant": "default"
    },
    {
      "id": "vehicle-buy",
      "title": "Buying a vehicle",
      "summary": "The cover, paperwork and payments around taking ownership.",
      "sections": [
        {
          "id": "before",
          "title": "Before collection",
          "summary": "Choose the dates that apply to your purchase.",
          "tasks": [
            {
              "id": "payment",
              "title": "Pay the agreed vehicle balance",
              "source": "provider",
              "hint": "Use your purchase agreement; skip if already paid.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange insurance before using the vehicle",
              "source": "plan",
              "hint": "Confirm the required cover and start date for your circumstances.",
              "optional": false
            },
            {
              "id": "collection",
              "title": "Vehicle collection",
              "source": "appointment",
              "hint": "Use the appointment agreed with the seller.",
              "optional": false
            }
          ]
        },
        {
          "id": "collection",
          "title": "Ownership and registration",
          "summary": "Your part of the process, separate from the seller's.",
          "tasks": [
            {
              "id": "complete-transfer",
              "title": "Complete your ownership-transfer step",
              "source": "provider",
              "hint": "Use the authority's process and actual deadline for your purchase.",
              "optional": false
            },
            {
              "id": "registration",
              "title": "Complete vehicle registration if required",
              "source": "provider",
              "hint": "Skip if completed through your ownership transfer or by the seller.",
              "optional": true
            },
            {
              "id": "parking",
              "title": "Update your resident parking permit",
              "source": "plan",
              "hint": "If you have a permit tied to the old vehicle.",
              "optional": true
            },
            {
              "id": "toll",
              "title": "Update your toll account with the new vehicle",
              "source": "plan",
              "hint": "Only if you use an account that needs changing.",
              "optional": true
            },
            {
              "id": "vehicle-tax",
              "title": "Arrange vehicle tax before road use",
              "source": "provider",
              "hint": "Use the official process for your vehicle; tax does not transfer with the purchase.",
              "optional": true
            }
          ]
        }
      ],
      "market": "GB",
      "sources": [
        ["Moving and vehicle records", "https://www.gov.uk/tell-dvla-changed-address"],
        ["Buying a vehicle", "https://www.gov.uk/buy-a-vehicle"]
      ],
      "count": 8,
      "variant": "default"
    },
    {
      "id": "job",
      "title": "Changing jobs",
      "summary": "Leave dates, final claims and paperwork for your new employer.",
      "sections": [
        {
          "id": "previous",
          "title": "Leaving your job",
          "summary": "Deadlines that can be missed during a handover.",
          "tasks": [
            {
              "id": "notice",
              "title": "Submit your resignation or leaving paperwork",
              "source": "provider",
              "hint": "Use your agreed notice arrangements.",
              "optional": true
            },
            {
              "id": "return",
              "title": "Return employer equipment or passes",
              "source": "provider",
              "hint": "Use the return deadline agreed with your employer.",
              "optional": true
            },
            {
              "id": "expenses",
              "title": "Submit outstanding expense claims",
              "source": "provider",
              "hint": "Use your employer's cutoff date.",
              "optional": true
            }
          ]
        },
        {
          "id": "before",
          "title": "Starting your new job",
          "summary": "Only the forms and choices your employer has requested.",
          "tasks": [
            {
              "id": "forms",
              "title": "Submit your new-starter forms",
              "source": "provider",
              "hint": "Use the date supplied by your employer.",
              "optional": false
            },
            {
              "id": "benefits",
              "title": "Submit your employee-benefit choices",
              "source": "provider",
              "hint": "If an enrolment or selection deadline applies.",
              "optional": true
            },
            {
              "id": "p45",
              "title": "Provide your P45 or requested starter information",
              "source": "provider",
              "hint": "Use your new employer's deadline; keep tax details outside this app.",
              "optional": true
            }
          ]
        }
      ],
      "market": "GB",
      "sources": [],
      "count": 6,
      "variant": "default"
    },
    {
      "id": "study",
      "title": "Starting university or college",
      "summary": "Offer, funding and accommodation deadlines for your next course.",
      "sections": [
        {
          "id": "place",
          "title": "Your place and funding",
          "summary": "Use the dates in your offer and funding information.",
          "tasks": [
            {
              "id": "offer",
              "title": "Accept your course offer",
              "source": "provider",
              "hint": "Use the response deadline in the offer.",
              "optional": false
            },
            {
              "id": "enrol",
              "title": "Complete enrolment",
              "source": "provider",
              "hint": "Use the institution's enrolment deadline.",
              "optional": false
            },
            {
              "id": "deposit",
              "title": "Pay the course deposit",
              "source": "provider",
              "hint": "Only if required by your offer.",
              "optional": true
            },
            {
              "id": "funding",
              "title": "Submit your student-funding application",
              "source": "provider",
              "hint": "Only for the scheme you have chosen and are eligible to apply for.",
              "optional": true
            }
          ]
        },
        {
          "id": "accommodation",
          "title": "Accommodation",
          "summary": "If you are taking a place away from home.",
          "tasks": [
            {
              "id": "offer-home",
              "title": "Accept your accommodation offer",
              "source": "provider",
              "hint": "Use the response deadline.",
              "optional": true
            },
            {
              "id": "deposit-home",
              "title": "Pay the accommodation deposit",
              "source": "provider",
              "hint": "Only if required and not included in another payment.",
              "optional": true
            },
            {
              "id": "keys",
              "title": "Accommodation key collection",
              "source": "appointment",
              "hint": "Use your agreed arrival appointment.",
              "optional": true
            }
          ]
        }
      ],
      "market": "GB",
      "sources": [],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "school",
      "title": "Applying for school or childcare",
      "summary": "Application, acceptance and payment dates for a place you are choosing.",
      "sections": [
        {
          "id": "place",
          "title": "Application and offer",
          "summary": "Your arrangements; no child profile is needed.",
          "tasks": [
            {
              "id": "apply",
              "title": "Submit the school or childcare application",
              "source": "provider",
              "hint": "Use the relevant authority or provider's application deadline.",
              "optional": false
            },
            {
              "id": "offer",
              "title": "Respond to the place offer",
              "source": "provider",
              "hint": "Use the deadline stated in the offer.",
              "optional": false
            },
            {
              "id": "forms",
              "title": "Return the requested enrolment forms",
              "source": "provider",
              "hint": "Only the forms requested for the accepted place.",
              "optional": true
            }
          ]
        },
        {
          "id": "start",
          "title": "Before the place starts",
          "summary": "Use the provider's confirmed dates.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Pay the place deposit",
              "source": "provider",
              "hint": "Only if required; skip if already paid.",
              "optional": true
            },
            {
              "id": "induction",
              "title": "Settling-in or induction appointment",
              "source": "appointment",
              "hint": "Only if you have a confirmed session.",
              "optional": true
            },
            {
              "id": "fees",
              "title": "Pay the first fee instalment",
              "source": "provider",
              "hint": "If fees apply and payment is not already automatic.",
              "optional": true
            }
          ]
        }
      ],
      "market": "GB",
      "sources": [],
      "count": 6,
      "variant": "default"
    },
    {
      "id": "marriage",
      "title": "Wedding deadlines and paperwork",
      "summary": "Registration appointments, supplier payments and return dates.",
      "sections": [
        {
          "id": "arrangements",
          "title": "Legal arrangements",
          "summary": "Follow the process for your chosen ceremony or registration.",
          "tasks": [
            {
              "id": "appointment",
              "title": "Notice or registration appointment",
              "source": "appointment",
              "hint": "Only if required by your local process; use the confirmed appointment.",
              "optional": true
            },
            {
              "id": "documents",
              "title": "Submit the documents requested for registration",
              "source": "provider",
              "hint": "Use the authority's actual deadline. No documents are uploaded here.",
              "optional": true
            }
          ]
        },
        {
          "id": "day",
          "title": "Booking deadlines",
          "summary": "Add a separate reminder for each supplier with a different due date.",
          "tasks": [
            {
              "id": "venue-deposit",
              "title": "Pay the venue or supplier deposit",
              "source": "provider",
              "hint": "Use the date in your booking agreement.",
              "optional": true
            },
            {
              "id": "numbers",
              "title": "Submit final guest numbers",
              "source": "provider",
              "hint": "Only if your venue or caterer has given a deadline.",
              "optional": true
            },
            {
              "id": "balance",
              "title": "Pay a supplier's final balance",
              "source": "provider",
              "hint": "Name the supplier and use their payment deadline.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the wedding",
          "summary": "Returns and paperwork that remain outstanding.",
          "tasks": [
            {
              "id": "returns",
              "title": "Return hired wedding items",
              "source": "provider",
              "hint": "Use the return deadline in your hire agreement.",
              "optional": true
            },
            {
              "id": "certificate",
              "title": "Request the marriage certificate",
              "source": "plan",
              "hint": "Only if your process requires a separate request.",
              "optional": true
            }
          ]
        }
      ],
      "market": "GB",
      "sources": [],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "move",
      "title": "Moving home",
      "summary": "Notice dates, services, address changes and getting your deposit back.",
      "sections": [
        {
          "id": "before",
          "title": "Before the move",
          "summary": "Choose the arrangements with a date you need to remember.",
          "tasks": [
            {
              "id": "notice",
              "title": "Give notice on your current tenancy",
              "source": "provider",
              "hint": "Only if you rent. Use your agreement and the rules that apply to your tenancy.",
              "optional": true
            },
            {
              "id": "removals",
              "title": "Removals or van booking",
              "source": "appointment",
              "hint": "Use your confirmed booking date.",
              "optional": true
            },
            {
              "id": "redirect",
              "title": "Arrange mail redirection",
              "source": "plan",
              "hint": "Choose when to apply, allowing for the postal service's lead time.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange home insurance for the new address",
              "source": "plan",
              "hint": "If needed, arrange cover before the start date agreed with your insurer.",
              "optional": true
            }
          ]
        },
        {
          "id": "leave",
          "title": "Leaving your old home",
          "summary": "Close accounts and keep the readings needed for your final bills.",
          "tasks": [
            {
              "id": "old-energy",
              "title": "Notify your old energy supplier",
              "source": "plan",
              "hint": "Give your move-out date using your supplier's process.",
              "optional": true
            },
            {
              "id": "old-water",
              "title": "Notify your old water supplier",
              "source": "plan",
              "hint": "If you hold a separate water account.",
              "optional": true
            },
            {
              "id": "old-internet",
              "title": "Arrange your internet transfer or cancellation",
              "source": "plan",
              "hint": "Allow for your provider's notice period. Choose the arrangement you actually need.",
              "optional": true
            },
            {
              "id": "final-energy",
              "title": "Record final energy meter readings",
              "source": "plan",
              "hint": "Choose your handover date. Keep the readings outside this app.",
              "optional": true
            },
            {
              "id": "final-water",
              "title": "Record the final water meter reading",
              "source": "plan",
              "hint": "Only if your property has a water meter you need to read.",
              "optional": true
            }
          ]
        },
        {
          "id": "arrive",
          "title": "At your new home",
          "summary": "Your handover and service arrangements.",
          "tasks": [
            {
              "id": "keys",
              "title": "New-home key handover",
              "source": "appointment",
              "hint": "Use the agreed handover date.",
              "optional": false
            },
            {
              "id": "new-energy",
              "title": "Set up the new energy account",
              "source": "plan",
              "hint": "If you are responsible for the supply.",
              "optional": true
            },
            {
              "id": "new-water",
              "title": "Set up the new water account",
              "source": "plan",
              "hint": "If a separate account is needed.",
              "optional": true
            },
            {
              "id": "new-internet",
              "title": "Internet installation appointment",
              "source": "appointment",
              "hint": "Only if an installation visit is booked.",
              "optional": true
            },
            {
              "id": "inventory",
              "title": "Return the checked inventory or condition report",
              "source": "provider",
              "hint": "If required, use the deadline in your handover instructions.",
              "optional": true
            }
          ]
        },
        {
          "id": "details",
          "title": "Update your address",
          "summary": "Choose the organisations you use. Each can have its own reminder.",
          "tasks": [
            {
              "id": "bank",
              "title": "Update your bank address",
              "source": "plan",
              "hint": "Add another reminder if a different bank needs a different date.",
              "optional": true
            },
            {
              "id": "employer",
              "title": "Update your employer's address records",
              "source": "plan",
              "hint": "If you need to update payroll or contact details.",
              "optional": true
            },
            {
              "id": "motor-cover",
              "title": "Update your motor-insurance address",
              "source": "plan",
              "hint": "Check with your insurer when the change needs to take effect.",
              "optional": true
            },
            {
              "id": "school",
              "title": "Update your school or childcare contact address",
              "source": "plan",
              "hint": "Only if relevant to your arrangements.",
              "optional": true
            },
            {
              "id": "pet-details",
              "title": "Update your pet's microchip contact details",
              "source": "plan",
              "hint": "Use the database holding your pet's registration.",
              "optional": true
            },
            {
              "id": "tenancy",
              "title": "Confirm your emirate's tenancy-registration steps",
              "source": "provider",
              "hint": "Dubai's Ejari process must not be assumed to apply in another emirate.",
              "optional": true
            },
            {
              "id": "official-address",
              "title": "Check which official address records need changing",
              "source": "provider",
              "hint": "Use the authority for your own residency and emirate.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the move",
          "summary": "Outstanding money and equipment with a return deadline.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Follow up your tenancy-deposit return",
              "source": "provider",
              "hint": "Use the expected return date agreed through your tenancy process.",
              "optional": true
            },
            {
              "id": "return-router",
              "title": "Return your old provider's router or equipment",
              "source": "provider",
              "hint": "Use the return deadline from your provider.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AE",
      "sources": [
        [
          "Dubai utility transfer",
          "https://dewa.gov.ae/en/consumer/supply-management/transfer-of-electricity-water-move-to"
        ]
      ],
      "count": 23,
      "variant": "default"
    },
    {
      "id": "holiday",
      "title": "Going on a booked holiday",
      "summary": "Payment deadlines, travel paperwork and arrangements before you leave.",
      "sections": [
        {
          "id": "essentials",
          "title": "Before you travel",
          "summary": "Use your booking and destination requirements.",
          "tasks": [
            {
              "id": "documents",
              "title": "Check passport validity and entry requirements",
              "source": "plan",
              "hint": "Choose a date early enough to act. Requirements depend on your destination and circumstances.",
              "optional": false
            },
            {
              "id": "document-apply",
              "title": "Submit the visa or travel-authorisation application",
              "source": "provider",
              "hint": "Only if required. Check the relevant authority's current process and processing time.",
              "optional": true
            },
            {
              "id": "balance",
              "title": "Pay the holiday booking balance",
              "source": "provider",
              "hint": "Use the due date in your booking. Skip if already paid.",
              "optional": true
            },
            {
              "id": "insurance",
              "title": "Arrange travel insurance",
              "source": "plan",
              "hint": "If you need cover, check when it needs to begin.",
              "optional": true
            }
          ]
        },
        {
          "id": "departure",
          "title": "Bookings to remember",
          "summary": "Only include bookings or deadlines you actually have.",
          "tasks": [
            {
              "id": "checkin",
              "title": "Complete airline online check-in",
              "source": "provider",
              "hint": "Use your airline's check-in window.",
              "optional": true
            },
            {
              "id": "pet-care",
              "title": "Confirm your pet's boarding or sitter booking",
              "source": "plan",
              "hint": "If your pet is staying behind; use the provider's confirmation deadline if supplied.",
              "optional": true
            },
            {
              "id": "parking",
              "title": "Pay a travel or airport-parking booking balance",
              "source": "provider",
              "hint": "Only if your existing booking has an outstanding payment.",
              "optional": true
            },
            {
              "id": "return-vehicle",
              "title": "Return the hire car",
              "source": "appointment",
              "hint": "Use the return date and time in your rental agreement.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AE",
      "sources": [],
      "count": 8,
      "variant": "default"
    },
    {
      "id": "pet",
      "title": "Your pet's care dates",
      "summary": "Vet dates, treatments, insurance and boarding requirements in one place.",
      "sections": [
        {
          "id": "care",
          "title": "Health and appointments",
          "summary": "Use dates already given by your vet or provider.",
          "tasks": [
            {
              "id": "vaccination",
              "title": "Pet vaccination due",
              "source": "care",
              "hint": "Use the next date given by your vet.",
              "optional": false
            },
            {
              "id": "flea",
              "title": "Pet flea treatment due",
              "source": "care",
              "hint": "Use the next treatment date given by your vet.",
              "optional": true
            },
            {
              "id": "worm",
              "title": "Pet worm treatment due",
              "source": "care",
              "hint": "Use the next treatment date given by your vet.",
              "optional": true
            },
            {
              "id": "medicine",
              "title": "Collect your pet's prescribed medicine",
              "source": "care",
              "hint": "Use the collection or refill date agreed with your vet.",
              "optional": true
            },
            {
              "id": "groom",
              "title": "Pet grooming appointment",
              "source": "appointment",
              "hint": "Use your confirmed booking.",
              "optional": true
            }
          ]
        },
        {
          "id": "records",
          "title": "Insurance and records",
          "summary": "Choose only the records that need attention.",
          "tasks": [
            {
              "id": "insurance",
              "title": "Pet-insurance renewal",
              "source": "provider",
              "hint": "Use the renewal date on your policy.",
              "optional": true
            },
            {
              "id": "chip-update",
              "title": "Update your pet's microchip details",
              "source": "plan",
              "hint": "Useful after a move, new phone number or change of keeper.",
              "optional": true
            },
            {
              "id": "registration-apply",
              "title": "Register or license your pet if required",
              "source": "provider",
              "hint": "Check the registration service for your emirate and animal.",
              "optional": true
            },
            {
              "id": "licence-renew",
              "title": "Renew an expiring pet licence",
              "source": "provider",
              "hint": "Only if your actual licence expires; skip lifetime registration.",
              "optional": true
            }
          ]
        },
        {
          "id": "away",
          "title": "Before boarding",
          "summary": "Requirements tied to a stay you have booked.",
          "tasks": [
            {
              "id": "requirements",
              "title": "Send the boarding provider's required records",
              "source": "provider",
              "hint": "Use their deadline and send records directly to the provider; there are no uploads here.",
              "optional": true
            },
            {
              "id": "boarding",
              "title": "Pet boarding drop-off",
              "source": "appointment",
              "hint": "Use the booking you have made.",
              "optional": true
            },
            {
              "id": "collect",
              "title": "Pet boarding collection",
              "source": "appointment",
              "hint": "Use the agreed collection date.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AE",
      "sources": [],
      "count": 12,
      "variant": "default"
    },
    {
      "id": "baby",
      "title": "New-baby paperwork and appointments",
      "summary": "Registration, parental leave, support applications and booked appointments.",
      "sections": [
        {
          "id": "leave",
          "title": "Leave and support",
          "summary": "Your own requests and applications, where applicable.",
          "tasks": [
            {
              "id": "leave-request",
              "title": "Submit your parental-leave request",
              "source": "provider",
              "hint": "Use your employer's process and the dates that apply to you.",
              "optional": true
            },
            {
              "id": "support-apply",
              "title": "Submit a family-benefit or support application",
              "source": "provider",
              "hint": "Only after checking eligibility and the actual application deadline.",
              "optional": true
            },
            {
              "id": "return-work",
              "title": "Confirm your return-to-work date",
              "source": "provider",
              "hint": "Use the notice arrangements agreed with your employer.",
              "optional": true
            }
          ]
        },
        {
          "id": "paperwork",
          "title": "Registration and cover",
          "summary": "Follow the process that applies where the birth is registered.",
          "tasks": [
            {
              "id": "register",
              "title": "Complete the applicable birth-registration step",
              "source": "provider",
              "hint": "Confirm the process with the hospital and relevant authority for your circumstances.",
              "optional": false
            },
            {
              "id": "certificate",
              "title": "Order a birth certificate if needed",
              "source": "plan",
              "hint": "Only if a separate request is needed. No certificate details or uploads are stored here.",
              "optional": true
            },
            {
              "id": "health-registration",
              "title": "Complete health-service or health-cover enrolment",
              "source": "provider",
              "hint": "If needed, use your health service or insurer's actual enrolment deadline.",
              "optional": true
            },
            {
              "id": "passport",
              "title": "Submit a passport application for planned travel",
              "source": "plan",
              "hint": "Only if needed for travel. Check the issuing authority's process.",
              "optional": true
            }
          ]
        },
        {
          "id": "appointments",
          "title": "Appointments and childcare",
          "summary": "Your reminders for dates already arranged.",
          "tasks": [
            {
              "id": "appointment",
              "title": "Health appointment",
              "source": "care",
              "hint": "Use the confirmed date from your practitioner; no care schedule is inferred.",
              "optional": true
            },
            {
              "id": "place",
              "title": "Respond to a childcare place offer",
              "source": "provider",
              "hint": "Use the acceptance deadline in the offer.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AE",
      "sources": [
        ["Having a baby", "https://u.ae/information-and-services/social-affairs/having-a-baby"]
      ],
      "count": 9,
      "variant": "default"
    },
    {
      "id": "vehicle-buy",
      "title": "Buying a vehicle",
      "summary": "The cover, paperwork and payments around taking ownership.",
      "sections": [
        {
          "id": "before",
          "title": "Before collection",
          "summary": "Choose the dates that apply to your purchase.",
          "tasks": [
            {
              "id": "payment",
              "title": "Pay the agreed vehicle balance",
              "source": "provider",
              "hint": "Use your purchase agreement; skip if already paid.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange insurance before using the vehicle",
              "source": "plan",
              "hint": "Confirm the required cover and start date for your circumstances.",
              "optional": false
            },
            {
              "id": "collection",
              "title": "Vehicle collection",
              "source": "appointment",
              "hint": "Use the appointment agreed with the seller.",
              "optional": false
            }
          ]
        },
        {
          "id": "collection",
          "title": "Ownership and registration",
          "summary": "Your part of the process, separate from the seller's.",
          "tasks": [
            {
              "id": "complete-transfer",
              "title": "Complete your ownership-transfer step",
              "source": "provider",
              "hint": "Use the authority's process and actual deadline for your purchase.",
              "optional": false
            },
            {
              "id": "registration",
              "title": "Complete vehicle registration if required",
              "source": "provider",
              "hint": "Skip if completed through your ownership transfer or by the seller.",
              "optional": true
            },
            {
              "id": "parking",
              "title": "Update your resident parking permit",
              "source": "plan",
              "hint": "If you have a permit tied to the old vehicle.",
              "optional": true
            },
            {
              "id": "toll",
              "title": "Update your toll account with the new vehicle",
              "source": "plan",
              "hint": "Only if you use an account that needs changing.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AE",
      "sources": [
        [
          "Vehicle registration",
          "https://u.ae/en/information-and-services/transportation/registering-vehicles"
        ]
      ],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "job",
      "title": "Changing jobs",
      "summary": "Leave dates, final claims and paperwork for your new employer.",
      "sections": [
        {
          "id": "previous",
          "title": "Leaving your job",
          "summary": "Deadlines that can be missed during a handover.",
          "tasks": [
            {
              "id": "notice",
              "title": "Submit your resignation or leaving paperwork",
              "source": "provider",
              "hint": "Use your agreed notice arrangements.",
              "optional": true
            },
            {
              "id": "return",
              "title": "Return employer equipment or passes",
              "source": "provider",
              "hint": "Use the return deadline agreed with your employer.",
              "optional": true
            },
            {
              "id": "expenses",
              "title": "Submit outstanding expense claims",
              "source": "provider",
              "hint": "Use your employer's cutoff date.",
              "optional": true
            }
          ]
        },
        {
          "id": "before",
          "title": "Starting your new job",
          "summary": "Only the forms and choices your employer has requested.",
          "tasks": [
            {
              "id": "forms",
              "title": "Submit your new-starter forms",
              "source": "provider",
              "hint": "Use the date supplied by your employer.",
              "optional": false
            },
            {
              "id": "benefits",
              "title": "Submit your employee-benefit choices",
              "source": "provider",
              "hint": "If an enrolment or selection deadline applies.",
              "optional": true
            },
            {
              "id": "permit",
              "title": "Provide information requested for your work or residence permit",
              "source": "provider",
              "hint": "Only your own requested step; confirm the employer's deadline.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AE",
      "sources": [],
      "count": 6,
      "variant": "default"
    },
    {
      "id": "study",
      "title": "Starting university or college",
      "summary": "Offer, funding and accommodation deadlines for your next course.",
      "sections": [
        {
          "id": "place",
          "title": "Your place and funding",
          "summary": "Use the dates in your offer and funding information.",
          "tasks": [
            {
              "id": "offer",
              "title": "Accept your course offer",
              "source": "provider",
              "hint": "Use the response deadline in the offer.",
              "optional": false
            },
            {
              "id": "enrol",
              "title": "Complete enrolment",
              "source": "provider",
              "hint": "Use the institution's enrolment deadline.",
              "optional": false
            },
            {
              "id": "deposit",
              "title": "Pay the course deposit",
              "source": "provider",
              "hint": "Only if required by your offer.",
              "optional": true
            },
            {
              "id": "funding",
              "title": "Submit your student-funding application",
              "source": "provider",
              "hint": "Only for the scheme you have chosen and are eligible to apply for.",
              "optional": true
            }
          ]
        },
        {
          "id": "accommodation",
          "title": "Accommodation",
          "summary": "If you are taking a place away from home.",
          "tasks": [
            {
              "id": "offer-home",
              "title": "Accept your accommodation offer",
              "source": "provider",
              "hint": "Use the response deadline.",
              "optional": true
            },
            {
              "id": "deposit-home",
              "title": "Pay the accommodation deposit",
              "source": "provider",
              "hint": "Only if required and not included in another payment.",
              "optional": true
            },
            {
              "id": "keys",
              "title": "Accommodation key collection",
              "source": "appointment",
              "hint": "Use your agreed arrival appointment.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AE",
      "sources": [],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "school",
      "title": "Applying for school or childcare",
      "summary": "Application, acceptance and payment dates for a place you are choosing.",
      "sections": [
        {
          "id": "place",
          "title": "Application and offer",
          "summary": "Your arrangements; no child profile is needed.",
          "tasks": [
            {
              "id": "apply",
              "title": "Submit the school or childcare application",
              "source": "provider",
              "hint": "Use the relevant authority or provider's application deadline.",
              "optional": false
            },
            {
              "id": "offer",
              "title": "Respond to the place offer",
              "source": "provider",
              "hint": "Use the deadline stated in the offer.",
              "optional": false
            },
            {
              "id": "forms",
              "title": "Return the requested enrolment forms",
              "source": "provider",
              "hint": "Only the forms requested for the accepted place.",
              "optional": true
            }
          ]
        },
        {
          "id": "start",
          "title": "Before the place starts",
          "summary": "Use the provider's confirmed dates.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Pay the place deposit",
              "source": "provider",
              "hint": "Only if required; skip if already paid.",
              "optional": true
            },
            {
              "id": "induction",
              "title": "Settling-in or induction appointment",
              "source": "appointment",
              "hint": "Only if you have a confirmed session.",
              "optional": true
            },
            {
              "id": "fees",
              "title": "Pay the first fee instalment",
              "source": "provider",
              "hint": "If fees apply and payment is not already automatic.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AE",
      "sources": [],
      "count": 6,
      "variant": "default"
    },
    {
      "id": "marriage",
      "title": "Wedding deadlines and paperwork",
      "summary": "Registration appointments, supplier payments and return dates.",
      "sections": [
        {
          "id": "arrangements",
          "title": "Legal arrangements",
          "summary": "Follow the process for your chosen ceremony or registration.",
          "tasks": [
            {
              "id": "appointment",
              "title": "Notice or registration appointment",
              "source": "appointment",
              "hint": "Only if required by your local process; use the confirmed appointment.",
              "optional": true
            },
            {
              "id": "documents",
              "title": "Submit the documents requested for registration",
              "source": "provider",
              "hint": "Use the authority's actual deadline. No documents are uploaded here.",
              "optional": true
            }
          ]
        },
        {
          "id": "day",
          "title": "Booking deadlines",
          "summary": "Add a separate reminder for each supplier with a different due date.",
          "tasks": [
            {
              "id": "venue-deposit",
              "title": "Pay the venue or supplier deposit",
              "source": "provider",
              "hint": "Use the date in your booking agreement.",
              "optional": true
            },
            {
              "id": "numbers",
              "title": "Submit final guest numbers",
              "source": "provider",
              "hint": "Only if your venue or caterer has given a deadline.",
              "optional": true
            },
            {
              "id": "balance",
              "title": "Pay a supplier's final balance",
              "source": "provider",
              "hint": "Name the supplier and use their payment deadline.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the wedding",
          "summary": "Returns and paperwork that remain outstanding.",
          "tasks": [
            {
              "id": "returns",
              "title": "Return hired wedding items",
              "source": "provider",
              "hint": "Use the return deadline in your hire agreement.",
              "optional": true
            },
            {
              "id": "certificate",
              "title": "Request the marriage certificate",
              "source": "plan",
              "hint": "Only if your process requires a separate request.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AE",
      "sources": [],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "move",
      "title": "Moving home",
      "summary": "Notice dates, services, address changes and getting your deposit back.",
      "sections": [
        {
          "id": "before",
          "title": "Before the move",
          "summary": "Choose the arrangements with a date you need to remember.",
          "tasks": [
            {
              "id": "notice",
              "title": "Give notice on your current tenancy",
              "source": "provider",
              "hint": "Only if you rent. Use your agreement and the rules that apply to your tenancy.",
              "optional": true
            },
            {
              "id": "removals",
              "title": "Removals or van booking",
              "source": "appointment",
              "hint": "Use your confirmed booking date.",
              "optional": true
            },
            {
              "id": "redirect",
              "title": "Arrange mail redirection",
              "source": "plan",
              "hint": "Choose when to apply, allowing for the postal service's lead time.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange home insurance for the new address",
              "source": "plan",
              "hint": "If needed, arrange cover before the start date agreed with your insurer.",
              "optional": true
            }
          ]
        },
        {
          "id": "leave",
          "title": "Leaving your old home",
          "summary": "Close accounts and keep the readings needed for your final bills.",
          "tasks": [
            {
              "id": "old-energy",
              "title": "Notify your old energy supplier",
              "source": "plan",
              "hint": "Give your move-out date using your supplier's process.",
              "optional": true
            },
            {
              "id": "old-water",
              "title": "Notify your old water supplier",
              "source": "plan",
              "hint": "If you hold a separate water account.",
              "optional": true
            },
            {
              "id": "old-internet",
              "title": "Arrange your internet transfer or cancellation",
              "source": "plan",
              "hint": "Allow for your provider's notice period. Choose the arrangement you actually need.",
              "optional": true
            },
            {
              "id": "final-energy",
              "title": "Record final energy meter readings",
              "source": "plan",
              "hint": "Choose your handover date. Keep the readings outside this app.",
              "optional": true
            },
            {
              "id": "final-water",
              "title": "Record the final water meter reading",
              "source": "plan",
              "hint": "Only if your property has a water meter you need to read.",
              "optional": true
            }
          ]
        },
        {
          "id": "arrive",
          "title": "At your new home",
          "summary": "Your handover and service arrangements.",
          "tasks": [
            {
              "id": "keys",
              "title": "New-home key handover",
              "source": "appointment",
              "hint": "Use the agreed handover date.",
              "optional": false
            },
            {
              "id": "new-energy",
              "title": "Set up the new energy account",
              "source": "plan",
              "hint": "If you are responsible for the supply.",
              "optional": true
            },
            {
              "id": "new-water",
              "title": "Set up the new water account",
              "source": "plan",
              "hint": "If a separate account is needed.",
              "optional": true
            },
            {
              "id": "new-internet",
              "title": "Internet installation appointment",
              "source": "appointment",
              "hint": "Only if an installation visit is booked.",
              "optional": true
            },
            {
              "id": "inventory",
              "title": "Return the checked inventory or condition report",
              "source": "provider",
              "hint": "If required, use the deadline in your handover instructions.",
              "optional": true
            }
          ]
        },
        {
          "id": "details",
          "title": "Update your address",
          "summary": "Choose the organisations you use. Each can have its own reminder.",
          "tasks": [
            {
              "id": "bank",
              "title": "Update your bank address",
              "source": "plan",
              "hint": "Add another reminder if a different bank needs a different date.",
              "optional": true
            },
            {
              "id": "employer",
              "title": "Update your employer's address records",
              "source": "plan",
              "hint": "If you need to update payroll or contact details.",
              "optional": true
            },
            {
              "id": "motor-cover",
              "title": "Update your motor-insurance address",
              "source": "plan",
              "hint": "Check with your insurer when the change needs to take effect.",
              "optional": true
            },
            {
              "id": "school",
              "title": "Update your school or childcare contact address",
              "source": "plan",
              "hint": "Only if relevant to your arrangements.",
              "optional": true
            },
            {
              "id": "pet-details",
              "title": "Update your pet's microchip contact details",
              "source": "plan",
              "hint": "Use the database holding your pet's registration.",
              "optional": true
            },
            {
              "id": "official-address",
              "title": "Update your address with the relevant authority",
              "source": "provider",
              "hint": "Use ICA or MOM's route as applicable to your citizen, permanent-resident or pass status.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the move",
          "summary": "Outstanding money and equipment with a return deadline.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Follow up your tenancy-deposit return",
              "source": "provider",
              "hint": "Use the expected return date agreed through your tenancy process.",
              "optional": true
            },
            {
              "id": "return-router",
              "title": "Return your old provider's router or equipment",
              "source": "provider",
              "hint": "Use the return deadline from your provider.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SG",
      "sources": [
        ["Address routes", "https://ask.gov.sg/singpass/questions/clul08v6p001mufi2ju0z5b09"],
        [
          "New HDB flat",
          "https://www.hdb.gov.sg/managing-my-home/home-ownership/checklist-for-moving-into-flat"
        ]
      ],
      "count": 22,
      "variant": "default"
    },
    {
      "id": "holiday",
      "title": "Going on a booked holiday",
      "summary": "Payment deadlines, travel paperwork and arrangements before you leave.",
      "sections": [
        {
          "id": "essentials",
          "title": "Before you travel",
          "summary": "Use your booking and destination requirements.",
          "tasks": [
            {
              "id": "documents",
              "title": "Check passport validity and entry requirements",
              "source": "plan",
              "hint": "Choose a date early enough to act. Requirements depend on your destination and circumstances.",
              "optional": false
            },
            {
              "id": "document-apply",
              "title": "Submit the visa or travel-authorisation application",
              "source": "provider",
              "hint": "Only if required. Check the relevant authority's current process and processing time.",
              "optional": true
            },
            {
              "id": "balance",
              "title": "Pay the holiday booking balance",
              "source": "provider",
              "hint": "Use the due date in your booking. Skip if already paid.",
              "optional": true
            },
            {
              "id": "insurance",
              "title": "Arrange travel insurance",
              "source": "plan",
              "hint": "If you need cover, check when it needs to begin.",
              "optional": true
            }
          ]
        },
        {
          "id": "departure",
          "title": "Bookings to remember",
          "summary": "Only include bookings or deadlines you actually have.",
          "tasks": [
            {
              "id": "checkin",
              "title": "Complete airline online check-in",
              "source": "provider",
              "hint": "Use your airline's check-in window.",
              "optional": true
            },
            {
              "id": "pet-care",
              "title": "Confirm your pet's boarding or sitter booking",
              "source": "plan",
              "hint": "If your pet is staying behind; use the provider's confirmation deadline if supplied.",
              "optional": true
            },
            {
              "id": "parking",
              "title": "Pay a travel or airport-parking booking balance",
              "source": "provider",
              "hint": "Only if your existing booking has an outstanding payment.",
              "optional": true
            },
            {
              "id": "return-vehicle",
              "title": "Return the hire car",
              "source": "appointment",
              "hint": "Use the return date and time in your rental agreement.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SG",
      "sources": [],
      "count": 8,
      "variant": "default"
    },
    {
      "id": "pet",
      "title": "Your pet's care dates",
      "summary": "Vet dates, treatments, insurance and boarding requirements in one place.",
      "sections": [
        {
          "id": "care",
          "title": "Health and appointments",
          "summary": "Use dates already given by your vet or provider.",
          "tasks": [
            {
              "id": "vaccination",
              "title": "Pet vaccination due",
              "source": "care",
              "hint": "Use the next date given by your vet.",
              "optional": false
            },
            {
              "id": "flea",
              "title": "Pet flea treatment due",
              "source": "care",
              "hint": "Use the next treatment date given by your vet.",
              "optional": true
            },
            {
              "id": "worm",
              "title": "Pet worm treatment due",
              "source": "care",
              "hint": "Use the next treatment date given by your vet.",
              "optional": true
            },
            {
              "id": "medicine",
              "title": "Collect your pet's prescribed medicine",
              "source": "care",
              "hint": "Use the collection or refill date agreed with your vet.",
              "optional": true
            },
            {
              "id": "groom",
              "title": "Pet grooming appointment",
              "source": "appointment",
              "hint": "Use your confirmed booking.",
              "optional": true
            }
          ]
        },
        {
          "id": "records",
          "title": "Insurance and records",
          "summary": "Choose only the records that need attention.",
          "tasks": [
            {
              "id": "insurance",
              "title": "Pet-insurance renewal",
              "source": "provider",
              "hint": "Use the renewal date on your policy.",
              "optional": true
            },
            {
              "id": "chip-update",
              "title": "Update your pet's microchip details",
              "source": "plan",
              "hint": "Useful after a move, new phone number or change of keeper.",
              "optional": true
            },
            {
              "id": "registration-apply",
              "title": "Register or license your pet if required",
              "source": "provider",
              "hint": "Check the current AVS licensing process for your pet.",
              "optional": true
            },
            {
              "id": "licence-renew",
              "title": "Renew an expiring pet licence",
              "source": "provider",
              "hint": "Only if your actual licence expires; skip lifetime registration.",
              "optional": true
            }
          ]
        },
        {
          "id": "away",
          "title": "Before boarding",
          "summary": "Requirements tied to a stay you have booked.",
          "tasks": [
            {
              "id": "requirements",
              "title": "Send the boarding provider's required records",
              "source": "provider",
              "hint": "Use their deadline and send records directly to the provider; there are no uploads here.",
              "optional": true
            },
            {
              "id": "boarding",
              "title": "Pet boarding drop-off",
              "source": "appointment",
              "hint": "Use the booking you have made.",
              "optional": true
            },
            {
              "id": "collect",
              "title": "Pet boarding collection",
              "source": "appointment",
              "hint": "Use the agreed collection date.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SG",
      "sources": [["Pet licensing", "https://avs.nparks.gov.sg/pets/licensing-a-pet/"]],
      "count": 12,
      "variant": "default"
    },
    {
      "id": "baby",
      "title": "New-baby paperwork and appointments",
      "summary": "Registration, parental leave, support applications and booked appointments.",
      "sections": [
        {
          "id": "leave",
          "title": "Leave and support",
          "summary": "Your own requests and applications, where applicable.",
          "tasks": [
            {
              "id": "leave-request",
              "title": "Submit your parental-leave request",
              "source": "provider",
              "hint": "Use your employer's process and the dates that apply to you.",
              "optional": true
            },
            {
              "id": "support-apply",
              "title": "Submit a family-benefit or support application",
              "source": "provider",
              "hint": "Only after checking eligibility and the actual application deadline.",
              "optional": true
            },
            {
              "id": "return-work",
              "title": "Confirm your return-to-work date",
              "source": "provider",
              "hint": "Use the notice arrangements agreed with your employer.",
              "optional": true
            }
          ]
        },
        {
          "id": "paperwork",
          "title": "Registration and cover",
          "summary": "Follow the process that applies where the birth is registered.",
          "tasks": [
            {
              "id": "register",
              "title": "Complete the applicable birth-registration step",
              "source": "provider",
              "hint": "Use ICA/LifeSG guidance for the applicable birth-registration process.",
              "optional": false
            },
            {
              "id": "certificate",
              "title": "Order a birth certificate if needed",
              "source": "plan",
              "hint": "Only if a separate request is needed. No certificate details or uploads are stored here.",
              "optional": true
            },
            {
              "id": "health-registration",
              "title": "Complete health-service or health-cover enrolment",
              "source": "provider",
              "hint": "If needed, use your health service or insurer's actual enrolment deadline.",
              "optional": true
            },
            {
              "id": "passport",
              "title": "Submit a passport application for planned travel",
              "source": "plan",
              "hint": "Only if needed for travel. Check the issuing authority's process.",
              "optional": true
            }
          ]
        },
        {
          "id": "appointments",
          "title": "Appointments and childcare",
          "summary": "Your reminders for dates already arranged.",
          "tasks": [
            {
              "id": "appointment",
              "title": "Health appointment",
              "source": "care",
              "hint": "Use the confirmed date from your practitioner; no care schedule is inferred.",
              "optional": true
            },
            {
              "id": "place",
              "title": "Respond to a childcare place offer",
              "source": "provider",
              "hint": "Use the acceptance deadline in the offer.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SG",
      "sources": [["Birth certificates", "https://www.ica.gov.sg/documents/birth-certificate"]],
      "count": 9,
      "variant": "default"
    },
    {
      "id": "vehicle-buy",
      "title": "Buying a vehicle",
      "summary": "The cover, paperwork and payments around taking ownership.",
      "sections": [
        {
          "id": "before",
          "title": "Before collection",
          "summary": "Choose the dates that apply to your purchase.",
          "tasks": [
            {
              "id": "payment",
              "title": "Pay the agreed vehicle balance",
              "source": "provider",
              "hint": "Use your purchase agreement; skip if already paid.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange insurance before using the vehicle",
              "source": "plan",
              "hint": "Confirm the required cover and start date for your circumstances.",
              "optional": false
            },
            {
              "id": "collection",
              "title": "Vehicle collection",
              "source": "appointment",
              "hint": "Use the appointment agreed with the seller.",
              "optional": false
            }
          ]
        },
        {
          "id": "collection",
          "title": "Ownership and registration",
          "summary": "Your part of the process, separate from the seller's.",
          "tasks": [
            {
              "id": "complete-transfer",
              "title": "Complete your ownership-transfer step",
              "source": "provider",
              "hint": "Use the authority's process and actual deadline for your purchase.",
              "optional": false
            },
            {
              "id": "registration",
              "title": "Complete vehicle registration if required",
              "source": "provider",
              "hint": "Skip if completed through your ownership transfer or by the seller.",
              "optional": true
            },
            {
              "id": "parking",
              "title": "Update your resident parking permit",
              "source": "plan",
              "hint": "If you have a permit tied to the old vehicle.",
              "optional": true
            },
            {
              "id": "toll",
              "title": "Update your toll account with the new vehicle",
              "source": "plan",
              "hint": "Only if you use an account that needs changing.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SG",
      "sources": [],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "job",
      "title": "Changing jobs",
      "summary": "Leave dates, final claims and paperwork for your new employer.",
      "sections": [
        {
          "id": "previous",
          "title": "Leaving your job",
          "summary": "Deadlines that can be missed during a handover.",
          "tasks": [
            {
              "id": "notice",
              "title": "Submit your resignation or leaving paperwork",
              "source": "provider",
              "hint": "Use your agreed notice arrangements.",
              "optional": true
            },
            {
              "id": "return",
              "title": "Return employer equipment or passes",
              "source": "provider",
              "hint": "Use the return deadline agreed with your employer.",
              "optional": true
            },
            {
              "id": "expenses",
              "title": "Submit outstanding expense claims",
              "source": "provider",
              "hint": "Use your employer's cutoff date.",
              "optional": true
            }
          ]
        },
        {
          "id": "before",
          "title": "Starting your new job",
          "summary": "Only the forms and choices your employer has requested.",
          "tasks": [
            {
              "id": "forms",
              "title": "Submit your new-starter forms",
              "source": "provider",
              "hint": "Use the date supplied by your employer.",
              "optional": false
            },
            {
              "id": "benefits",
              "title": "Submit your employee-benefit choices",
              "source": "provider",
              "hint": "If an enrolment or selection deadline applies.",
              "optional": true
            },
            {
              "id": "work-pass",
              "title": "Complete your requested work-pass step",
              "source": "provider",
              "hint": "Follow your employer's instructions for your applicable pass.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SG",
      "sources": [
        [
          "Employment Pass steps",
          "https://www.mom.gov.sg/passes-and-permits/employment-pass/apply-for-a-pass"
        ]
      ],
      "count": 6,
      "variant": "default"
    },
    {
      "id": "study",
      "title": "Starting university or college",
      "summary": "Offer, funding and accommodation deadlines for your next course.",
      "sections": [
        {
          "id": "place",
          "title": "Your place and funding",
          "summary": "Use the dates in your offer and funding information.",
          "tasks": [
            {
              "id": "offer",
              "title": "Accept your course offer",
              "source": "provider",
              "hint": "Use the response deadline in the offer.",
              "optional": false
            },
            {
              "id": "enrol",
              "title": "Complete enrolment",
              "source": "provider",
              "hint": "Use the institution's enrolment deadline.",
              "optional": false
            },
            {
              "id": "deposit",
              "title": "Pay the course deposit",
              "source": "provider",
              "hint": "Only if required by your offer.",
              "optional": true
            },
            {
              "id": "funding",
              "title": "Submit your student-funding application",
              "source": "provider",
              "hint": "Only for the scheme you have chosen and are eligible to apply for.",
              "optional": true
            }
          ]
        },
        {
          "id": "accommodation",
          "title": "Accommodation",
          "summary": "If you are taking a place away from home.",
          "tasks": [
            {
              "id": "offer-home",
              "title": "Accept your accommodation offer",
              "source": "provider",
              "hint": "Use the response deadline.",
              "optional": true
            },
            {
              "id": "deposit-home",
              "title": "Pay the accommodation deposit",
              "source": "provider",
              "hint": "Only if required and not included in another payment.",
              "optional": true
            },
            {
              "id": "keys",
              "title": "Accommodation key collection",
              "source": "appointment",
              "hint": "Use your agreed arrival appointment.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SG",
      "sources": [],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "school",
      "title": "Applying for school or childcare",
      "summary": "Application, acceptance and payment dates for a place you are choosing.",
      "sections": [
        {
          "id": "place",
          "title": "Application and offer",
          "summary": "Your arrangements; no child profile is needed.",
          "tasks": [
            {
              "id": "apply",
              "title": "Submit the school or childcare application",
              "source": "provider",
              "hint": "Use the relevant authority or provider's application deadline.",
              "optional": false
            },
            {
              "id": "offer",
              "title": "Respond to the place offer",
              "source": "provider",
              "hint": "Use the deadline stated in the offer.",
              "optional": false
            },
            {
              "id": "forms",
              "title": "Return the requested enrolment forms",
              "source": "provider",
              "hint": "Only the forms requested for the accepted place.",
              "optional": true
            }
          ]
        },
        {
          "id": "start",
          "title": "Before the place starts",
          "summary": "Use the provider's confirmed dates.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Pay the place deposit",
              "source": "provider",
              "hint": "Only if required; skip if already paid.",
              "optional": true
            },
            {
              "id": "induction",
              "title": "Settling-in or induction appointment",
              "source": "appointment",
              "hint": "Only if you have a confirmed session.",
              "optional": true
            },
            {
              "id": "fees",
              "title": "Pay the first fee instalment",
              "source": "provider",
              "hint": "If fees apply and payment is not already automatic.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SG",
      "sources": [],
      "count": 6,
      "variant": "default"
    },
    {
      "id": "marriage",
      "title": "Wedding deadlines and paperwork",
      "summary": "Registration appointments, supplier payments and return dates.",
      "sections": [
        {
          "id": "arrangements",
          "title": "Legal arrangements",
          "summary": "Follow the process for your chosen ceremony or registration.",
          "tasks": [
            {
              "id": "appointment",
              "title": "Notice or registration appointment",
              "source": "appointment",
              "hint": "Only if required by your local process; use the confirmed appointment.",
              "optional": true
            },
            {
              "id": "documents",
              "title": "Submit the documents requested for registration",
              "source": "provider",
              "hint": "Use the authority's actual deadline. No documents are uploaded here.",
              "optional": true
            }
          ]
        },
        {
          "id": "day",
          "title": "Booking deadlines",
          "summary": "Add a separate reminder for each supplier with a different due date.",
          "tasks": [
            {
              "id": "venue-deposit",
              "title": "Pay the venue or supplier deposit",
              "source": "provider",
              "hint": "Use the date in your booking agreement.",
              "optional": true
            },
            {
              "id": "numbers",
              "title": "Submit final guest numbers",
              "source": "provider",
              "hint": "Only if your venue or caterer has given a deadline.",
              "optional": true
            },
            {
              "id": "balance",
              "title": "Pay a supplier's final balance",
              "source": "provider",
              "hint": "Name the supplier and use their payment deadline.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the wedding",
          "summary": "Returns and paperwork that remain outstanding.",
          "tasks": [
            {
              "id": "returns",
              "title": "Return hired wedding items",
              "source": "provider",
              "hint": "Use the return deadline in your hire agreement.",
              "optional": true
            },
            {
              "id": "certificate",
              "title": "Request the marriage certificate",
              "source": "plan",
              "hint": "Only if your process requires a separate request.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SG",
      "sources": [],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "move",
      "title": "Moving home",
      "summary": "Notice dates, services, address changes and getting your deposit back.",
      "sections": [
        {
          "id": "before",
          "title": "Before the move",
          "summary": "Choose the arrangements with a date you need to remember.",
          "tasks": [
            {
              "id": "notice",
              "title": "Give notice on your current tenancy",
              "source": "provider",
              "hint": "Only if you rent. Use your agreement and the rules that apply to your tenancy.",
              "optional": true
            },
            {
              "id": "removals",
              "title": "Removals or van booking",
              "source": "appointment",
              "hint": "Use your confirmed booking date.",
              "optional": true
            },
            {
              "id": "redirect",
              "title": "Arrange mail redirection",
              "source": "plan",
              "hint": "Choose when to apply, allowing for the postal service's lead time.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange home insurance for the new address",
              "source": "plan",
              "hint": "If needed, arrange cover before the start date agreed with your insurer.",
              "optional": true
            }
          ]
        },
        {
          "id": "leave",
          "title": "Leaving your old home",
          "summary": "Close accounts and keep the readings needed for your final bills.",
          "tasks": [
            {
              "id": "old-energy",
              "title": "Notify your old energy supplier",
              "source": "plan",
              "hint": "Give your move-out date using your supplier's process.",
              "optional": true
            },
            {
              "id": "old-water",
              "title": "Notify your old water supplier",
              "source": "plan",
              "hint": "If you hold a separate water account.",
              "optional": true
            },
            {
              "id": "old-internet",
              "title": "Arrange your internet transfer or cancellation",
              "source": "plan",
              "hint": "Allow for your provider's notice period. Choose the arrangement you actually need.",
              "optional": true
            },
            {
              "id": "final-energy",
              "title": "Record final energy meter readings",
              "source": "plan",
              "hint": "Choose your handover date. Keep the readings outside this app.",
              "optional": true
            },
            {
              "id": "final-water",
              "title": "Record the final water meter reading",
              "source": "plan",
              "hint": "Only if your property has a water meter you need to read.",
              "optional": true
            }
          ]
        },
        {
          "id": "arrive",
          "title": "At your new home",
          "summary": "Your handover and service arrangements.",
          "tasks": [
            {
              "id": "keys",
              "title": "New-home key handover",
              "source": "appointment",
              "hint": "Use the agreed handover date.",
              "optional": false
            },
            {
              "id": "new-energy",
              "title": "Set up the new energy account",
              "source": "plan",
              "hint": "If you are responsible for the supply.",
              "optional": true
            },
            {
              "id": "new-water",
              "title": "Set up the new water account",
              "source": "plan",
              "hint": "If a separate account is needed.",
              "optional": true
            },
            {
              "id": "new-internet",
              "title": "Internet installation appointment",
              "source": "appointment",
              "hint": "Only if an installation visit is booked.",
              "optional": true
            },
            {
              "id": "inventory",
              "title": "Return the checked inventory or condition report",
              "source": "provider",
              "hint": "If required, use the deadline in your handover instructions.",
              "optional": true
            }
          ]
        },
        {
          "id": "details",
          "title": "Update your address",
          "summary": "Choose the organisations you use. Each can have its own reminder.",
          "tasks": [
            {
              "id": "bank",
              "title": "Update your bank address",
              "source": "plan",
              "hint": "Add another reminder if a different bank needs a different date.",
              "optional": true
            },
            {
              "id": "employer",
              "title": "Update your employer's address records",
              "source": "plan",
              "hint": "If you need to update payroll or contact details.",
              "optional": true
            },
            {
              "id": "motor-cover",
              "title": "Update your motor-insurance address",
              "source": "plan",
              "hint": "Check with your insurer when the change needs to take effect.",
              "optional": true
            },
            {
              "id": "school",
              "title": "Update your school or childcare contact address",
              "source": "plan",
              "hint": "Only if relevant to your arrangements.",
              "optional": true
            },
            {
              "id": "pet-details",
              "title": "Update your pet's microchip contact details",
              "source": "plan",
              "hint": "Use the database holding your pet's registration.",
              "optional": true
            },
            {
              "id": "national-address",
              "title": "Update your National Address",
              "source": "provider",
              "hint": "Use the official address-management service.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the move",
          "summary": "Outstanding money and equipment with a return deadline.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Follow up your tenancy-deposit return",
              "source": "provider",
              "hint": "Use the expected return date agreed through your tenancy process.",
              "optional": true
            },
            {
              "id": "return-router",
              "title": "Return your old provider's router or equipment",
              "source": "provider",
              "hint": "Use the return deadline from your provider.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SA",
      "sources": [["National Address", "https://my.gov.sa/services/119858"]],
      "count": 22,
      "variant": "default"
    },
    {
      "id": "holiday",
      "title": "Going on a booked holiday",
      "summary": "Payment deadlines, travel paperwork and arrangements before you leave.",
      "sections": [
        {
          "id": "essentials",
          "title": "Before you travel",
          "summary": "Use your booking and destination requirements.",
          "tasks": [
            {
              "id": "documents",
              "title": "Check passport validity and entry requirements",
              "source": "plan",
              "hint": "Choose a date early enough to act. Requirements depend on your destination and circumstances.",
              "optional": false
            },
            {
              "id": "document-apply",
              "title": "Submit the visa or travel-authorisation application",
              "source": "provider",
              "hint": "Only if required. Check the relevant authority's current process and processing time.",
              "optional": true
            },
            {
              "id": "balance",
              "title": "Pay the holiday booking balance",
              "source": "provider",
              "hint": "Use the due date in your booking. Skip if already paid.",
              "optional": true
            },
            {
              "id": "insurance",
              "title": "Arrange travel insurance",
              "source": "plan",
              "hint": "If you need cover, check when it needs to begin.",
              "optional": true
            }
          ]
        },
        {
          "id": "departure",
          "title": "Bookings to remember",
          "summary": "Only include bookings or deadlines you actually have.",
          "tasks": [
            {
              "id": "checkin",
              "title": "Complete airline online check-in",
              "source": "provider",
              "hint": "Use your airline's check-in window.",
              "optional": true
            },
            {
              "id": "pet-care",
              "title": "Confirm your pet's boarding or sitter booking",
              "source": "plan",
              "hint": "If your pet is staying behind; use the provider's confirmation deadline if supplied.",
              "optional": true
            },
            {
              "id": "parking",
              "title": "Pay a travel or airport-parking booking balance",
              "source": "provider",
              "hint": "Only if your existing booking has an outstanding payment.",
              "optional": true
            },
            {
              "id": "return-vehicle",
              "title": "Return the hire car",
              "source": "appointment",
              "hint": "Use the return date and time in your rental agreement.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SA",
      "sources": [],
      "count": 8,
      "variant": "default"
    },
    {
      "id": "pet",
      "title": "Your pet's care dates",
      "summary": "Vet dates, treatments, insurance and boarding requirements in one place.",
      "sections": [
        {
          "id": "care",
          "title": "Health and appointments",
          "summary": "Use dates already given by your vet or provider.",
          "tasks": [
            {
              "id": "vaccination",
              "title": "Pet vaccination due",
              "source": "care",
              "hint": "Use the next date given by your vet.",
              "optional": false
            },
            {
              "id": "flea",
              "title": "Pet flea treatment due",
              "source": "care",
              "hint": "Use the next treatment date given by your vet.",
              "optional": true
            },
            {
              "id": "worm",
              "title": "Pet worm treatment due",
              "source": "care",
              "hint": "Use the next treatment date given by your vet.",
              "optional": true
            },
            {
              "id": "medicine",
              "title": "Collect your pet's prescribed medicine",
              "source": "care",
              "hint": "Use the collection or refill date agreed with your vet.",
              "optional": true
            },
            {
              "id": "groom",
              "title": "Pet grooming appointment",
              "source": "appointment",
              "hint": "Use your confirmed booking.",
              "optional": true
            }
          ]
        },
        {
          "id": "records",
          "title": "Insurance and records",
          "summary": "Choose only the records that need attention.",
          "tasks": [
            {
              "id": "insurance",
              "title": "Pet-insurance renewal",
              "source": "provider",
              "hint": "Use the renewal date on your policy.",
              "optional": true
            },
            {
              "id": "chip-update",
              "title": "Update your pet's microchip details",
              "source": "plan",
              "hint": "Useful after a move, new phone number or change of keeper.",
              "optional": true
            }
          ]
        },
        {
          "id": "away",
          "title": "Before boarding",
          "summary": "Requirements tied to a stay you have booked.",
          "tasks": [
            {
              "id": "requirements",
              "title": "Send the boarding provider's required records",
              "source": "provider",
              "hint": "Use their deadline and send records directly to the provider; there are no uploads here.",
              "optional": true
            },
            {
              "id": "boarding",
              "title": "Pet boarding drop-off",
              "source": "appointment",
              "hint": "Use the booking you have made.",
              "optional": true
            },
            {
              "id": "collect",
              "title": "Pet boarding collection",
              "source": "appointment",
              "hint": "Use the agreed collection date.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SA",
      "sources": [],
      "count": 10,
      "variant": "default"
    },
    {
      "id": "baby",
      "title": "New-baby paperwork and appointments",
      "summary": "Registration, parental leave, support applications and booked appointments.",
      "sections": [
        {
          "id": "leave",
          "title": "Leave and support",
          "summary": "Your own requests and applications, where applicable.",
          "tasks": [
            {
              "id": "leave-request",
              "title": "Submit your parental-leave request",
              "source": "provider",
              "hint": "Use your employer's process and the dates that apply to you.",
              "optional": true
            },
            {
              "id": "support-apply",
              "title": "Submit a family-benefit or support application",
              "source": "provider",
              "hint": "Only after checking eligibility and the actual application deadline.",
              "optional": true
            },
            {
              "id": "return-work",
              "title": "Confirm your return-to-work date",
              "source": "provider",
              "hint": "Use the notice arrangements agreed with your employer.",
              "optional": true
            }
          ]
        },
        {
          "id": "paperwork",
          "title": "Registration and cover",
          "summary": "Follow the process that applies where the birth is registered.",
          "tasks": [
            {
              "id": "register",
              "title": "Complete the applicable birth-registration step",
              "source": "provider",
              "hint": "Confirm the applicable hospital and civil-registration process.",
              "optional": false
            },
            {
              "id": "certificate",
              "title": "Order a birth certificate if needed",
              "source": "plan",
              "hint": "Only if a separate request is needed. No certificate details or uploads are stored here.",
              "optional": true
            },
            {
              "id": "health-registration",
              "title": "Complete health-service or health-cover enrolment",
              "source": "provider",
              "hint": "If needed, use your health service or insurer's actual enrolment deadline.",
              "optional": true
            },
            {
              "id": "passport",
              "title": "Submit a passport application for planned travel",
              "source": "plan",
              "hint": "Only if needed for travel. Check the issuing authority's process.",
              "optional": true
            }
          ]
        },
        {
          "id": "appointments",
          "title": "Appointments and childcare",
          "summary": "Your reminders for dates already arranged.",
          "tasks": [
            {
              "id": "appointment",
              "title": "Health appointment",
              "source": "care",
              "hint": "Use the confirmed date from your practitioner; no care schedule is inferred.",
              "optional": true
            },
            {
              "id": "place",
              "title": "Respond to a childcare place offer",
              "source": "provider",
              "hint": "Use the acceptance deadline in the offer.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SA",
      "sources": [
        [
          "Birth-registration information",
          "https://www.absher.sa/wps/wcm/connect/individuals/contents/individuals/FAQs_EN"
        ]
      ],
      "count": 9,
      "variant": "default"
    },
    {
      "id": "vehicle-buy",
      "title": "Buying a vehicle",
      "summary": "The cover, paperwork and payments around taking ownership.",
      "sections": [
        {
          "id": "before",
          "title": "Before collection",
          "summary": "Choose the dates that apply to your purchase.",
          "tasks": [
            {
              "id": "payment",
              "title": "Pay the agreed vehicle balance",
              "source": "provider",
              "hint": "Use your purchase agreement; skip if already paid.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange insurance before using the vehicle",
              "source": "plan",
              "hint": "Confirm the required cover and start date for your circumstances.",
              "optional": false
            },
            {
              "id": "collection",
              "title": "Vehicle collection",
              "source": "appointment",
              "hint": "Use the appointment agreed with the seller.",
              "optional": false
            }
          ]
        },
        {
          "id": "collection",
          "title": "Ownership and registration",
          "summary": "Your part of the process, separate from the seller's.",
          "tasks": [
            {
              "id": "complete-transfer",
              "title": "Complete your ownership-transfer step",
              "source": "provider",
              "hint": "Use the authority's process and actual deadline for your purchase.",
              "optional": false
            },
            {
              "id": "registration",
              "title": "Complete vehicle registration if required",
              "source": "provider",
              "hint": "Skip if completed through your ownership transfer or by the seller.",
              "optional": true
            },
            {
              "id": "parking",
              "title": "Update your resident parking permit",
              "source": "plan",
              "hint": "If you have a permit tied to the old vehicle.",
              "optional": true
            },
            {
              "id": "toll",
              "title": "Update your toll account with the new vehicle",
              "source": "plan",
              "hint": "Only if you use an account that needs changing.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SA",
      "sources": [["Vehicle transfer", "https://my.gov.sa/en/services/112114"]],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "job",
      "title": "Changing jobs",
      "summary": "Leave dates, final claims and paperwork for your new employer.",
      "sections": [
        {
          "id": "previous",
          "title": "Leaving your job",
          "summary": "Deadlines that can be missed during a handover.",
          "tasks": [
            {
              "id": "notice",
              "title": "Submit your resignation or leaving paperwork",
              "source": "provider",
              "hint": "Use your agreed notice arrangements.",
              "optional": true
            },
            {
              "id": "return",
              "title": "Return employer equipment or passes",
              "source": "provider",
              "hint": "Use the return deadline agreed with your employer.",
              "optional": true
            },
            {
              "id": "expenses",
              "title": "Submit outstanding expense claims",
              "source": "provider",
              "hint": "Use your employer's cutoff date.",
              "optional": true
            }
          ]
        },
        {
          "id": "before",
          "title": "Starting your new job",
          "summary": "Only the forms and choices your employer has requested.",
          "tasks": [
            {
              "id": "forms",
              "title": "Submit your new-starter forms",
              "source": "provider",
              "hint": "Use the date supplied by your employer.",
              "optional": false
            },
            {
              "id": "benefits",
              "title": "Submit your employee-benefit choices",
              "source": "provider",
              "hint": "If an enrolment or selection deadline applies.",
              "optional": true
            },
            {
              "id": "transfer",
              "title": "Respond to your employment-transfer request",
              "source": "provider",
              "hint": "Only if applicable to your move between employers; use the official process.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SA",
      "sources": [
        [
          "Employee transfer",
          "https://www.qiwa.sa/en/service-overview/employees/manage-your-current-job/employee-transfer"
        ]
      ],
      "count": 6,
      "variant": "default"
    },
    {
      "id": "study",
      "title": "Starting university or college",
      "summary": "Offer, funding and accommodation deadlines for your next course.",
      "sections": [
        {
          "id": "place",
          "title": "Your place and funding",
          "summary": "Use the dates in your offer and funding information.",
          "tasks": [
            {
              "id": "offer",
              "title": "Accept your course offer",
              "source": "provider",
              "hint": "Use the response deadline in the offer.",
              "optional": false
            },
            {
              "id": "enrol",
              "title": "Complete enrolment",
              "source": "provider",
              "hint": "Use the institution's enrolment deadline.",
              "optional": false
            },
            {
              "id": "deposit",
              "title": "Pay the course deposit",
              "source": "provider",
              "hint": "Only if required by your offer.",
              "optional": true
            },
            {
              "id": "funding",
              "title": "Submit your student-funding application",
              "source": "provider",
              "hint": "Only for the scheme you have chosen and are eligible to apply for.",
              "optional": true
            }
          ]
        },
        {
          "id": "accommodation",
          "title": "Accommodation",
          "summary": "If you are taking a place away from home.",
          "tasks": [
            {
              "id": "offer-home",
              "title": "Accept your accommodation offer",
              "source": "provider",
              "hint": "Use the response deadline.",
              "optional": true
            },
            {
              "id": "deposit-home",
              "title": "Pay the accommodation deposit",
              "source": "provider",
              "hint": "Only if required and not included in another payment.",
              "optional": true
            },
            {
              "id": "keys",
              "title": "Accommodation key collection",
              "source": "appointment",
              "hint": "Use your agreed arrival appointment.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SA",
      "sources": [],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "school",
      "title": "Applying for school or childcare",
      "summary": "Application, acceptance and payment dates for a place you are choosing.",
      "sections": [
        {
          "id": "place",
          "title": "Application and offer",
          "summary": "Your arrangements; no child profile is needed.",
          "tasks": [
            {
              "id": "apply",
              "title": "Submit the school or childcare application",
              "source": "provider",
              "hint": "Use the relevant authority or provider's application deadline.",
              "optional": false
            },
            {
              "id": "offer",
              "title": "Respond to the place offer",
              "source": "provider",
              "hint": "Use the deadline stated in the offer.",
              "optional": false
            },
            {
              "id": "forms",
              "title": "Return the requested enrolment forms",
              "source": "provider",
              "hint": "Only the forms requested for the accepted place.",
              "optional": true
            }
          ]
        },
        {
          "id": "start",
          "title": "Before the place starts",
          "summary": "Use the provider's confirmed dates.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Pay the place deposit",
              "source": "provider",
              "hint": "Only if required; skip if already paid.",
              "optional": true
            },
            {
              "id": "induction",
              "title": "Settling-in or induction appointment",
              "source": "appointment",
              "hint": "Only if you have a confirmed session.",
              "optional": true
            },
            {
              "id": "fees",
              "title": "Pay the first fee instalment",
              "source": "provider",
              "hint": "If fees apply and payment is not already automatic.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SA",
      "sources": [],
      "count": 6,
      "variant": "default"
    },
    {
      "id": "marriage",
      "title": "Wedding deadlines and paperwork",
      "summary": "Registration appointments, supplier payments and return dates.",
      "sections": [
        {
          "id": "arrangements",
          "title": "Legal arrangements",
          "summary": "Follow the process for your chosen ceremony or registration.",
          "tasks": [
            {
              "id": "appointment",
              "title": "Notice or registration appointment",
              "source": "appointment",
              "hint": "Only if required by your local process; use the confirmed appointment.",
              "optional": true
            },
            {
              "id": "documents",
              "title": "Submit the documents requested for registration",
              "source": "provider",
              "hint": "Use the authority's actual deadline. No documents are uploaded here.",
              "optional": true
            }
          ]
        },
        {
          "id": "day",
          "title": "Booking deadlines",
          "summary": "Add a separate reminder for each supplier with a different due date.",
          "tasks": [
            {
              "id": "venue-deposit",
              "title": "Pay the venue or supplier deposit",
              "source": "provider",
              "hint": "Use the date in your booking agreement.",
              "optional": true
            },
            {
              "id": "numbers",
              "title": "Submit final guest numbers",
              "source": "provider",
              "hint": "Only if your venue or caterer has given a deadline.",
              "optional": true
            },
            {
              "id": "balance",
              "title": "Pay a supplier's final balance",
              "source": "provider",
              "hint": "Name the supplier and use their payment deadline.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the wedding",
          "summary": "Returns and paperwork that remain outstanding.",
          "tasks": [
            {
              "id": "returns",
              "title": "Return hired wedding items",
              "source": "provider",
              "hint": "Use the return deadline in your hire agreement.",
              "optional": true
            },
            {
              "id": "certificate",
              "title": "Request the marriage certificate",
              "source": "plan",
              "hint": "Only if your process requires a separate request.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SA",
      "sources": [],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "move",
      "title": "Moving home",
      "summary": "Notice dates, services, address changes and getting your deposit back.",
      "sections": [
        {
          "id": "before",
          "title": "Before the move",
          "summary": "Choose the arrangements with a date you need to remember.",
          "tasks": [
            {
              "id": "notice",
              "title": "Give notice on your current tenancy",
              "source": "provider",
              "hint": "Only if you rent. Use your agreement and the rules that apply to your tenancy.",
              "optional": true
            },
            {
              "id": "removals",
              "title": "Removals or van booking",
              "source": "appointment",
              "hint": "Use your confirmed booking date.",
              "optional": true
            },
            {
              "id": "redirect",
              "title": "Arrange mail redirection",
              "source": "plan",
              "hint": "Choose when to apply, allowing for the postal service's lead time.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange home insurance for the new address",
              "source": "plan",
              "hint": "If needed, arrange cover before the start date agreed with your insurer.",
              "optional": true
            }
          ]
        },
        {
          "id": "leave",
          "title": "Leaving your old home",
          "summary": "Close accounts and keep the readings needed for your final bills.",
          "tasks": [
            {
              "id": "old-energy",
              "title": "Notify your old energy supplier",
              "source": "plan",
              "hint": "Give your move-out date using your supplier's process.",
              "optional": true
            },
            {
              "id": "old-water",
              "title": "Notify your old water supplier",
              "source": "plan",
              "hint": "If you hold a separate water account.",
              "optional": true
            },
            {
              "id": "old-internet",
              "title": "Arrange your internet transfer or cancellation",
              "source": "plan",
              "hint": "Allow for your provider's notice period. Choose the arrangement you actually need.",
              "optional": true
            },
            {
              "id": "final-energy",
              "title": "Record final energy meter readings",
              "source": "plan",
              "hint": "Choose your handover date. Keep the readings outside this app.",
              "optional": true
            },
            {
              "id": "final-water",
              "title": "Record the final water meter reading",
              "source": "plan",
              "hint": "Only if your property has a water meter you need to read.",
              "optional": true
            }
          ]
        },
        {
          "id": "arrive",
          "title": "At your new home",
          "summary": "Your handover and service arrangements.",
          "tasks": [
            {
              "id": "keys",
              "title": "New-home key handover",
              "source": "appointment",
              "hint": "Use the agreed handover date.",
              "optional": false
            },
            {
              "id": "new-energy",
              "title": "Set up the new energy account",
              "source": "plan",
              "hint": "If you are responsible for the supply.",
              "optional": true
            },
            {
              "id": "new-water",
              "title": "Set up the new water account",
              "source": "plan",
              "hint": "If a separate account is needed.",
              "optional": true
            },
            {
              "id": "new-internet",
              "title": "Internet installation appointment",
              "source": "appointment",
              "hint": "Only if an installation visit is booked.",
              "optional": true
            },
            {
              "id": "inventory",
              "title": "Return the checked inventory or condition report",
              "source": "provider",
              "hint": "If required, use the deadline in your handover instructions.",
              "optional": true
            }
          ]
        },
        {
          "id": "details",
          "title": "Update your address",
          "summary": "Choose the organisations you use. Each can have its own reminder.",
          "tasks": [
            {
              "id": "bank",
              "title": "Update your bank address",
              "source": "plan",
              "hint": "Add another reminder if a different bank needs a different date.",
              "optional": true
            },
            {
              "id": "employer",
              "title": "Update your employer's address records",
              "source": "plan",
              "hint": "If you need to update payroll or contact details.",
              "optional": true
            },
            {
              "id": "motor-cover",
              "title": "Update your motor-insurance address",
              "source": "plan",
              "hint": "Check with your insurer when the change needs to take effect.",
              "optional": true
            },
            {
              "id": "school",
              "title": "Update your school or childcare contact address",
              "source": "plan",
              "hint": "Only if relevant to your arrangements.",
              "optional": true
            },
            {
              "id": "pet-details",
              "title": "Update your pet's microchip contact details",
              "source": "plan",
              "hint": "Use the database holding your pet's registration.",
              "optional": true
            },
            {
              "id": "aadhaar",
              "title": "Update your Aadhaar address if needed",
              "source": "provider",
              "hint": "Use UIDAI's requirements for your own update.",
              "optional": true
            },
            {
              "id": "vehicle-address",
              "title": "Update the vehicle registration address",
              "source": "provider",
              "hint": "Check your state/RTO's process, especially after an interstate move.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the move",
          "summary": "Outstanding money and equipment with a return deadline.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Follow up your tenancy-deposit return",
              "source": "provider",
              "hint": "Use the expected return date agreed through your tenancy process.",
              "optional": true
            },
            {
              "id": "return-router",
              "title": "Return your old provider's router or equipment",
              "source": "provider",
              "hint": "Use the return deadline from your provider.",
              "optional": true
            }
          ]
        }
      ],
      "market": "IN",
      "sources": [["Aadhaar address guidance", "https://uidai.gov.in/en/921-faqs/aadhaar-online"]],
      "count": 23,
      "variant": "default"
    },
    {
      "id": "holiday",
      "title": "Going on a booked holiday",
      "summary": "Payment deadlines, travel paperwork and arrangements before you leave.",
      "sections": [
        {
          "id": "essentials",
          "title": "Before you travel",
          "summary": "Use your booking and destination requirements.",
          "tasks": [
            {
              "id": "documents",
              "title": "Check passport validity and entry requirements",
              "source": "plan",
              "hint": "Choose a date early enough to act. Requirements depend on your destination and circumstances.",
              "optional": false
            },
            {
              "id": "document-apply",
              "title": "Submit the visa or travel-authorisation application",
              "source": "provider",
              "hint": "Only if required. Check the relevant authority's current process and processing time.",
              "optional": true
            },
            {
              "id": "balance",
              "title": "Pay the holiday booking balance",
              "source": "provider",
              "hint": "Use the due date in your booking. Skip if already paid.",
              "optional": true
            },
            {
              "id": "insurance",
              "title": "Arrange travel insurance",
              "source": "plan",
              "hint": "If you need cover, check when it needs to begin.",
              "optional": true
            }
          ]
        },
        {
          "id": "departure",
          "title": "Bookings to remember",
          "summary": "Only include bookings or deadlines you actually have.",
          "tasks": [
            {
              "id": "checkin",
              "title": "Complete airline online check-in",
              "source": "provider",
              "hint": "Use your airline's check-in window.",
              "optional": true
            },
            {
              "id": "pet-care",
              "title": "Confirm your pet's boarding or sitter booking",
              "source": "plan",
              "hint": "If your pet is staying behind; use the provider's confirmation deadline if supplied.",
              "optional": true
            },
            {
              "id": "parking",
              "title": "Pay a travel or airport-parking booking balance",
              "source": "provider",
              "hint": "Only if your existing booking has an outstanding payment.",
              "optional": true
            },
            {
              "id": "return-vehicle",
              "title": "Return the hire car",
              "source": "appointment",
              "hint": "Use the return date and time in your rental agreement.",
              "optional": true
            }
          ]
        }
      ],
      "market": "IN",
      "sources": [],
      "count": 8,
      "variant": "default"
    },
    {
      "id": "pet",
      "title": "Your pet's care dates",
      "summary": "Vet dates, treatments, insurance and boarding requirements in one place.",
      "sections": [
        {
          "id": "care",
          "title": "Health and appointments",
          "summary": "Use dates already given by your vet or provider.",
          "tasks": [
            {
              "id": "vaccination",
              "title": "Pet vaccination due",
              "source": "care",
              "hint": "Use the next date given by your vet.",
              "optional": false
            },
            {
              "id": "flea",
              "title": "Pet flea treatment due",
              "source": "care",
              "hint": "Use the next treatment date given by your vet.",
              "optional": true
            },
            {
              "id": "worm",
              "title": "Pet worm treatment due",
              "source": "care",
              "hint": "Use the next treatment date given by your vet.",
              "optional": true
            },
            {
              "id": "medicine",
              "title": "Collect your pet's prescribed medicine",
              "source": "care",
              "hint": "Use the collection or refill date agreed with your vet.",
              "optional": true
            },
            {
              "id": "groom",
              "title": "Pet grooming appointment",
              "source": "appointment",
              "hint": "Use your confirmed booking.",
              "optional": true
            }
          ]
        },
        {
          "id": "records",
          "title": "Insurance and records",
          "summary": "Choose only the records that need attention.",
          "tasks": [
            {
              "id": "insurance",
              "title": "Pet-insurance renewal",
              "source": "provider",
              "hint": "Use the renewal date on your policy.",
              "optional": true
            },
            {
              "id": "chip-update",
              "title": "Update your pet's microchip details",
              "source": "plan",
              "hint": "Useful after a move, new phone number or change of keeper.",
              "optional": true
            },
            {
              "id": "registration-apply",
              "title": "Register or license your pet if required",
              "source": "provider",
              "hint": "Check your municipality's requirements; local schemes differ.",
              "optional": true
            },
            {
              "id": "licence-renew",
              "title": "Renew an expiring pet licence",
              "source": "provider",
              "hint": "Only if your actual licence expires; skip lifetime registration.",
              "optional": true
            }
          ]
        },
        {
          "id": "away",
          "title": "Before boarding",
          "summary": "Requirements tied to a stay you have booked.",
          "tasks": [
            {
              "id": "requirements",
              "title": "Send the boarding provider's required records",
              "source": "provider",
              "hint": "Use their deadline and send records directly to the provider; there are no uploads here.",
              "optional": true
            },
            {
              "id": "boarding",
              "title": "Pet boarding drop-off",
              "source": "appointment",
              "hint": "Use the booking you have made.",
              "optional": true
            },
            {
              "id": "collect",
              "title": "Pet boarding collection",
              "source": "appointment",
              "hint": "Use the agreed collection date.",
              "optional": true
            }
          ]
        }
      ],
      "market": "IN",
      "sources": [
        ["Delhi dog-registration example", "https://mcdonline.nic.in/petmcd/web/citizen/info"]
      ],
      "count": 12,
      "variant": "default"
    },
    {
      "id": "baby",
      "title": "New-baby paperwork and appointments",
      "summary": "Registration, parental leave, support applications and booked appointments.",
      "sections": [
        {
          "id": "leave",
          "title": "Leave and support",
          "summary": "Your own requests and applications, where applicable.",
          "tasks": [
            {
              "id": "leave-request",
              "title": "Submit your parental-leave request",
              "source": "provider",
              "hint": "Use your employer's process and the dates that apply to you.",
              "optional": true
            },
            {
              "id": "support-apply",
              "title": "Submit a family-benefit or support application",
              "source": "provider",
              "hint": "Only after checking eligibility and the actual application deadline.",
              "optional": true
            },
            {
              "id": "return-work",
              "title": "Confirm your return-to-work date",
              "source": "provider",
              "hint": "Use the notice arrangements agreed with your employer.",
              "optional": true
            }
          ]
        },
        {
          "id": "paperwork",
          "title": "Registration and cover",
          "summary": "Follow the process that applies where the birth is registered.",
          "tasks": [
            {
              "id": "register",
              "title": "Complete the applicable birth-registration step",
              "source": "provider",
              "hint": "Check whether the hospital has reported the birth and which local authority handles registration.",
              "optional": false
            },
            {
              "id": "certificate",
              "title": "Order a birth certificate if needed",
              "source": "plan",
              "hint": "Only if a separate request is needed. No certificate details or uploads are stored here.",
              "optional": true
            },
            {
              "id": "health-registration",
              "title": "Complete health-service or health-cover enrolment",
              "source": "provider",
              "hint": "If needed, use your health service or insurer's actual enrolment deadline.",
              "optional": true
            },
            {
              "id": "passport",
              "title": "Submit a passport application for planned travel",
              "source": "plan",
              "hint": "Only if needed for travel. Check the issuing authority's process.",
              "optional": true
            }
          ]
        },
        {
          "id": "appointments",
          "title": "Appointments and childcare",
          "summary": "Your reminders for dates already arranged.",
          "tasks": [
            {
              "id": "appointment",
              "title": "Health appointment",
              "source": "care",
              "hint": "Use the confirmed date from your practitioner; no care schedule is inferred.",
              "optional": true
            },
            {
              "id": "place",
              "title": "Respond to a childcare place offer",
              "source": "provider",
              "hint": "Use the acceptance deadline in the offer.",
              "optional": true
            }
          ]
        }
      ],
      "market": "IN",
      "sources": [
        [
          "Birth registration",
          "https://services.india.gov.in/service/detail/civil-registration-system-birth-and-death-certificate"
        ]
      ],
      "count": 9,
      "variant": "default"
    },
    {
      "id": "vehicle-buy",
      "title": "Buying a vehicle",
      "summary": "The cover, paperwork and payments around taking ownership.",
      "sections": [
        {
          "id": "before",
          "title": "Before collection",
          "summary": "Choose the dates that apply to your purchase.",
          "tasks": [
            {
              "id": "payment",
              "title": "Pay the agreed vehicle balance",
              "source": "provider",
              "hint": "Use your purchase agreement; skip if already paid.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange insurance before using the vehicle",
              "source": "plan",
              "hint": "Confirm the required cover and start date for your circumstances.",
              "optional": false
            },
            {
              "id": "collection",
              "title": "Vehicle collection",
              "source": "appointment",
              "hint": "Use the appointment agreed with the seller.",
              "optional": false
            }
          ]
        },
        {
          "id": "collection",
          "title": "Ownership and registration",
          "summary": "Your part of the process, separate from the seller's.",
          "tasks": [
            {
              "id": "complete-transfer",
              "title": "Complete your ownership-transfer step",
              "source": "provider",
              "hint": "Use the authority's process and actual deadline for your purchase.",
              "optional": false
            },
            {
              "id": "registration",
              "title": "Complete vehicle registration if required",
              "source": "provider",
              "hint": "Skip if completed through your ownership transfer or by the seller.",
              "optional": true
            },
            {
              "id": "parking",
              "title": "Update your resident parking permit",
              "source": "plan",
              "hint": "If you have a permit tied to the old vehicle.",
              "optional": true
            },
            {
              "id": "toll",
              "title": "Update your toll account with the new vehicle",
              "source": "plan",
              "hint": "Only if you use an account that needs changing.",
              "optional": true
            }
          ]
        }
      ],
      "market": "IN",
      "sources": [
        [
          "Vehicle ownership transfer",
          "https://mparivahan.parivahan.gov.in/mstatic/english/rc-info-ownership.html"
        ]
      ],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "job",
      "title": "Changing jobs",
      "summary": "Leave dates, final claims and paperwork for your new employer.",
      "sections": [
        {
          "id": "previous",
          "title": "Leaving your job",
          "summary": "Deadlines that can be missed during a handover.",
          "tasks": [
            {
              "id": "notice",
              "title": "Submit your resignation or leaving paperwork",
              "source": "provider",
              "hint": "Use your agreed notice arrangements.",
              "optional": true
            },
            {
              "id": "return",
              "title": "Return employer equipment or passes",
              "source": "provider",
              "hint": "Use the return deadline agreed with your employer.",
              "optional": true
            },
            {
              "id": "expenses",
              "title": "Submit outstanding expense claims",
              "source": "provider",
              "hint": "Use your employer's cutoff date.",
              "optional": true
            }
          ]
        },
        {
          "id": "before",
          "title": "Starting your new job",
          "summary": "Only the forms and choices your employer has requested.",
          "tasks": [
            {
              "id": "forms",
              "title": "Submit your new-starter forms",
              "source": "provider",
              "hint": "Use the date supplied by your employer.",
              "optional": false
            },
            {
              "id": "benefits",
              "title": "Submit your employee-benefit choices",
              "source": "provider",
              "hint": "If an enrolment or selection deadline applies.",
              "optional": true
            },
            {
              "id": "uan",
              "title": "Provide your existing UAN to your new employer",
              "source": "provider",
              "hint": "Only if applicable; use the employer's requested date.",
              "optional": true
            }
          ]
        }
      ],
      "market": "IN",
      "sources": [],
      "count": 6,
      "variant": "default"
    },
    {
      "id": "study",
      "title": "Starting university or college",
      "summary": "Offer, funding and accommodation deadlines for your next course.",
      "sections": [
        {
          "id": "place",
          "title": "Your place and funding",
          "summary": "Use the dates in your offer and funding information.",
          "tasks": [
            {
              "id": "offer",
              "title": "Accept your course offer",
              "source": "provider",
              "hint": "Use the response deadline in the offer.",
              "optional": false
            },
            {
              "id": "enrol",
              "title": "Complete enrolment",
              "source": "provider",
              "hint": "Use the institution's enrolment deadline.",
              "optional": false
            },
            {
              "id": "deposit",
              "title": "Pay the course deposit",
              "source": "provider",
              "hint": "Only if required by your offer.",
              "optional": true
            },
            {
              "id": "funding",
              "title": "Submit your student-funding application",
              "source": "provider",
              "hint": "Only for the scheme you have chosen and are eligible to apply for.",
              "optional": true
            }
          ]
        },
        {
          "id": "accommodation",
          "title": "Accommodation",
          "summary": "If you are taking a place away from home.",
          "tasks": [
            {
              "id": "offer-home",
              "title": "Accept your accommodation offer",
              "source": "provider",
              "hint": "Use the response deadline.",
              "optional": true
            },
            {
              "id": "deposit-home",
              "title": "Pay the accommodation deposit",
              "source": "provider",
              "hint": "Only if required and not included in another payment.",
              "optional": true
            },
            {
              "id": "keys",
              "title": "Accommodation key collection",
              "source": "appointment",
              "hint": "Use your agreed arrival appointment.",
              "optional": true
            }
          ]
        }
      ],
      "market": "IN",
      "sources": [],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "school",
      "title": "Applying for school or childcare",
      "summary": "Application, acceptance and payment dates for a place you are choosing.",
      "sections": [
        {
          "id": "place",
          "title": "Application and offer",
          "summary": "Your arrangements; no child profile is needed.",
          "tasks": [
            {
              "id": "apply",
              "title": "Submit the school or childcare application",
              "source": "provider",
              "hint": "Use the relevant authority or provider's application deadline.",
              "optional": false
            },
            {
              "id": "offer",
              "title": "Respond to the place offer",
              "source": "provider",
              "hint": "Use the deadline stated in the offer.",
              "optional": false
            },
            {
              "id": "forms",
              "title": "Return the requested enrolment forms",
              "source": "provider",
              "hint": "Only the forms requested for the accepted place.",
              "optional": true
            }
          ]
        },
        {
          "id": "start",
          "title": "Before the place starts",
          "summary": "Use the provider's confirmed dates.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Pay the place deposit",
              "source": "provider",
              "hint": "Only if required; skip if already paid.",
              "optional": true
            },
            {
              "id": "induction",
              "title": "Settling-in or induction appointment",
              "source": "appointment",
              "hint": "Only if you have a confirmed session.",
              "optional": true
            },
            {
              "id": "fees",
              "title": "Pay the first fee instalment",
              "source": "provider",
              "hint": "If fees apply and payment is not already automatic.",
              "optional": true
            }
          ]
        }
      ],
      "market": "IN",
      "sources": [],
      "count": 6,
      "variant": "default"
    },
    {
      "id": "marriage",
      "title": "Wedding deadlines and paperwork",
      "summary": "Registration appointments, supplier payments and return dates.",
      "sections": [
        {
          "id": "arrangements",
          "title": "Legal arrangements",
          "summary": "Follow the process for your chosen ceremony or registration.",
          "tasks": [
            {
              "id": "appointment",
              "title": "Notice or registration appointment",
              "source": "appointment",
              "hint": "Only if required by your local process; use the confirmed appointment.",
              "optional": true
            },
            {
              "id": "documents",
              "title": "Submit the documents requested for registration",
              "source": "provider",
              "hint": "Use the authority's actual deadline. No documents are uploaded here.",
              "optional": true
            }
          ]
        },
        {
          "id": "day",
          "title": "Booking deadlines",
          "summary": "Add a separate reminder for each supplier with a different due date.",
          "tasks": [
            {
              "id": "venue-deposit",
              "title": "Pay the venue or supplier deposit",
              "source": "provider",
              "hint": "Use the date in your booking agreement.",
              "optional": true
            },
            {
              "id": "numbers",
              "title": "Submit final guest numbers",
              "source": "provider",
              "hint": "Only if your venue or caterer has given a deadline.",
              "optional": true
            },
            {
              "id": "balance",
              "title": "Pay a supplier's final balance",
              "source": "provider",
              "hint": "Name the supplier and use their payment deadline.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the wedding",
          "summary": "Returns and paperwork that remain outstanding.",
          "tasks": [
            {
              "id": "returns",
              "title": "Return hired wedding items",
              "source": "provider",
              "hint": "Use the return deadline in your hire agreement.",
              "optional": true
            },
            {
              "id": "certificate",
              "title": "Request the marriage certificate",
              "source": "plan",
              "hint": "Only if your process requires a separate request.",
              "optional": true
            }
          ]
        }
      ],
      "market": "IN",
      "sources": [],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "move",
      "title": "Moving home",
      "summary": "Notice dates, services, address changes and getting your deposit back.",
      "sections": [
        {
          "id": "before",
          "title": "Before the move",
          "summary": "Choose the arrangements with a date you need to remember.",
          "tasks": [
            {
              "id": "notice",
              "title": "Give notice on your current tenancy",
              "source": "provider",
              "hint": "Only if you rent. Use your agreement and the rules that apply to your tenancy.",
              "optional": true
            },
            {
              "id": "removals",
              "title": "Removals or van booking",
              "source": "appointment",
              "hint": "Use your confirmed booking date.",
              "optional": true
            },
            {
              "id": "redirect",
              "title": "Arrange mail redirection",
              "source": "plan",
              "hint": "Choose when to apply, allowing for the postal service's lead time.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange home insurance for the new address",
              "source": "plan",
              "hint": "If needed, arrange cover before the start date agreed with your insurer.",
              "optional": true
            }
          ]
        },
        {
          "id": "leave",
          "title": "Leaving your old home",
          "summary": "Close accounts and keep the readings needed for your final bills.",
          "tasks": [
            {
              "id": "old-energy",
              "title": "Notify your old energy supplier",
              "source": "plan",
              "hint": "Give your move-out date using your supplier's process.",
              "optional": true
            },
            {
              "id": "old-water",
              "title": "Notify your old water supplier",
              "source": "plan",
              "hint": "If you hold a separate water account.",
              "optional": true
            },
            {
              "id": "old-internet",
              "title": "Arrange your internet transfer or cancellation",
              "source": "plan",
              "hint": "Allow for your provider's notice period. Choose the arrangement you actually need.",
              "optional": true
            },
            {
              "id": "final-energy",
              "title": "Record final energy meter readings",
              "source": "plan",
              "hint": "Choose your handover date. Keep the readings outside this app.",
              "optional": true
            },
            {
              "id": "final-water",
              "title": "Record the final water meter reading",
              "source": "plan",
              "hint": "Only if your property has a water meter you need to read.",
              "optional": true
            }
          ]
        },
        {
          "id": "arrive",
          "title": "At your new home",
          "summary": "Your handover and service arrangements.",
          "tasks": [
            {
              "id": "keys",
              "title": "New-home key handover",
              "source": "appointment",
              "hint": "Use the agreed handover date.",
              "optional": false
            },
            {
              "id": "new-energy",
              "title": "Set up the new energy account",
              "source": "plan",
              "hint": "If you are responsible for the supply.",
              "optional": true
            },
            {
              "id": "new-water",
              "title": "Set up the new water account",
              "source": "plan",
              "hint": "If a separate account is needed.",
              "optional": true
            },
            {
              "id": "new-internet",
              "title": "Internet installation appointment",
              "source": "appointment",
              "hint": "Only if an installation visit is booked.",
              "optional": true
            },
            {
              "id": "inventory",
              "title": "Return the checked inventory or condition report",
              "source": "provider",
              "hint": "If required, use the deadline in your handover instructions.",
              "optional": true
            }
          ]
        },
        {
          "id": "details",
          "title": "Update your address",
          "summary": "Choose the organisations you use. Each can have its own reminder.",
          "tasks": [
            {
              "id": "bank",
              "title": "Update your bank address",
              "source": "plan",
              "hint": "Add another reminder if a different bank needs a different date.",
              "optional": true
            },
            {
              "id": "employer",
              "title": "Update your employer's address records",
              "source": "plan",
              "hint": "If you need to update payroll or contact details.",
              "optional": true
            },
            {
              "id": "motor-cover",
              "title": "Update your motor-insurance address",
              "source": "plan",
              "hint": "Check with your insurer when the change needs to take effect.",
              "optional": true
            },
            {
              "id": "school",
              "title": "Update your school or childcare contact address",
              "source": "plan",
              "hint": "Only if relevant to your arrangements.",
              "optional": true
            },
            {
              "id": "pet-details",
              "title": "Update your pet's microchip contact details",
              "source": "plan",
              "hint": "Use the database holding your pet's registration.",
              "optional": true
            },
            {
              "id": "services",
              "title": "Update your address with Services Australia",
              "source": "provider",
              "hint": "If you use a service that needs the new address.",
              "optional": true
            },
            {
              "id": "licence",
              "title": "Check the destination state's driver-licence steps",
              "source": "provider",
              "hint": "Only if applicable; deadlines vary by state or territory.",
              "optional": true
            },
            {
              "id": "vehicle",
              "title": "Check the destination state's vehicle-registration steps",
              "source": "provider",
              "hint": "This is separate from the driver's licence update.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the move",
          "summary": "Outstanding money and equipment with a return deadline.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Follow up your tenancy-deposit return",
              "source": "provider",
              "hint": "Use the expected return date agreed through your tenancy process.",
              "optional": true
            },
            {
              "id": "return-router",
              "title": "Return your old provider's router or equipment",
              "source": "provider",
              "hint": "Use the return deadline from your provider.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AU",
      "sources": [
        ["Moving house", "https://www.servicesaustralia.gov.au/moving-house?context=60023"]
      ],
      "count": 24,
      "variant": "default"
    },
    {
      "id": "holiday",
      "title": "Going on a booked holiday",
      "summary": "Payment deadlines, travel paperwork and arrangements before you leave.",
      "sections": [
        {
          "id": "essentials",
          "title": "Before you travel",
          "summary": "Use your booking and destination requirements.",
          "tasks": [
            {
              "id": "documents",
              "title": "Check passport validity and entry requirements",
              "source": "plan",
              "hint": "Choose a date early enough to act. Requirements depend on your destination and circumstances.",
              "optional": false
            },
            {
              "id": "document-apply",
              "title": "Submit the visa or travel-authorisation application",
              "source": "provider",
              "hint": "Only if required. Check the relevant authority's current process and processing time.",
              "optional": true
            },
            {
              "id": "balance",
              "title": "Pay the holiday booking balance",
              "source": "provider",
              "hint": "Use the due date in your booking. Skip if already paid.",
              "optional": true
            },
            {
              "id": "insurance",
              "title": "Arrange travel insurance",
              "source": "plan",
              "hint": "If you need cover, check when it needs to begin.",
              "optional": true
            }
          ]
        },
        {
          "id": "departure",
          "title": "Bookings to remember",
          "summary": "Only include bookings or deadlines you actually have.",
          "tasks": [
            {
              "id": "checkin",
              "title": "Complete airline online check-in",
              "source": "provider",
              "hint": "Use your airline's check-in window.",
              "optional": true
            },
            {
              "id": "pet-care",
              "title": "Confirm your pet's boarding or sitter booking",
              "source": "plan",
              "hint": "If your pet is staying behind; use the provider's confirmation deadline if supplied.",
              "optional": true
            },
            {
              "id": "parking",
              "title": "Pay a travel or airport-parking booking balance",
              "source": "provider",
              "hint": "Only if your existing booking has an outstanding payment.",
              "optional": true
            },
            {
              "id": "return-vehicle",
              "title": "Return the hire car",
              "source": "appointment",
              "hint": "Use the return date and time in your rental agreement.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AU",
      "sources": [],
      "count": 8,
      "variant": "default"
    },
    {
      "id": "pet",
      "title": "Your pet's care dates",
      "summary": "Vet dates, treatments, insurance and boarding requirements in one place.",
      "sections": [
        {
          "id": "care",
          "title": "Health and appointments",
          "summary": "Use dates already given by your vet or provider.",
          "tasks": [
            {
              "id": "vaccination",
              "title": "Pet vaccination due",
              "source": "care",
              "hint": "Use the next date given by your vet.",
              "optional": false
            },
            {
              "id": "flea",
              "title": "Pet flea treatment due",
              "source": "care",
              "hint": "Use the next treatment date given by your vet.",
              "optional": true
            },
            {
              "id": "worm",
              "title": "Pet worm treatment due",
              "source": "care",
              "hint": "Use the next treatment date given by your vet.",
              "optional": true
            },
            {
              "id": "medicine",
              "title": "Collect your pet's prescribed medicine",
              "source": "care",
              "hint": "Use the collection or refill date agreed with your vet.",
              "optional": true
            },
            {
              "id": "groom",
              "title": "Pet grooming appointment",
              "source": "appointment",
              "hint": "Use your confirmed booking.",
              "optional": true
            }
          ]
        },
        {
          "id": "records",
          "title": "Insurance and records",
          "summary": "Choose only the records that need attention.",
          "tasks": [
            {
              "id": "insurance",
              "title": "Pet-insurance renewal",
              "source": "provider",
              "hint": "Use the renewal date on your policy.",
              "optional": true
            },
            {
              "id": "chip-update",
              "title": "Update your pet's microchip details",
              "source": "plan",
              "hint": "Useful after a move, new phone number or change of keeper.",
              "optional": true
            },
            {
              "id": "registration-apply",
              "title": "Register or license your pet if required",
              "source": "provider",
              "hint": "Check your state and council; some registrations are lifetime.",
              "optional": true
            },
            {
              "id": "licence-renew",
              "title": "Renew an expiring pet licence",
              "source": "provider",
              "hint": "Only if your actual licence expires; skip lifetime registration.",
              "optional": true
            }
          ]
        },
        {
          "id": "away",
          "title": "Before boarding",
          "summary": "Requirements tied to a stay you have booked.",
          "tasks": [
            {
              "id": "requirements",
              "title": "Send the boarding provider's required records",
              "source": "provider",
              "hint": "Use their deadline and send records directly to the provider; there are no uploads here.",
              "optional": true
            },
            {
              "id": "boarding",
              "title": "Pet boarding drop-off",
              "source": "appointment",
              "hint": "Use the booking you have made.",
              "optional": true
            },
            {
              "id": "collect",
              "title": "Pet boarding collection",
              "source": "appointment",
              "hint": "Use the agreed collection date.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AU",
      "sources": [
        [
          "NSW pet registration",
          "https://www.service.nsw.gov.au/transaction/register-your-dog-or-cat-in-nsw"
        ]
      ],
      "count": 12,
      "variant": "default"
    },
    {
      "id": "baby",
      "title": "New-baby paperwork and appointments",
      "summary": "Registration, parental leave, support applications and booked appointments.",
      "sections": [
        {
          "id": "leave",
          "title": "Leave and support",
          "summary": "Your own requests and applications, where applicable.",
          "tasks": [
            {
              "id": "leave-request",
              "title": "Submit your parental-leave request",
              "source": "provider",
              "hint": "Use your employer's process and the dates that apply to you.",
              "optional": true
            },
            {
              "id": "support-apply",
              "title": "Submit a family-benefit or support application",
              "source": "provider",
              "hint": "Only after checking eligibility and the actual application deadline.",
              "optional": true
            },
            {
              "id": "return-work",
              "title": "Confirm your return-to-work date",
              "source": "provider",
              "hint": "Use the notice arrangements agreed with your employer.",
              "optional": true
            }
          ]
        },
        {
          "id": "paperwork",
          "title": "Registration and cover",
          "summary": "Follow the process that applies where the birth is registered.",
          "tasks": [
            {
              "id": "register",
              "title": "Complete the applicable birth-registration step",
              "source": "provider",
              "hint": "Use the birth state or territory's process. Registration and ordering a certificate may be separate.",
              "optional": false
            },
            {
              "id": "certificate",
              "title": "Order a birth certificate if needed",
              "source": "plan",
              "hint": "Only if a separate request is needed. No certificate details or uploads are stored here.",
              "optional": true
            },
            {
              "id": "health-registration",
              "title": "Complete health-service or health-cover enrolment",
              "source": "provider",
              "hint": "If needed, use your health service or insurer's actual enrolment deadline.",
              "optional": true
            },
            {
              "id": "passport",
              "title": "Submit a passport application for planned travel",
              "source": "plan",
              "hint": "Only if needed for travel. Check the issuing authority's process.",
              "optional": true
            }
          ]
        },
        {
          "id": "appointments",
          "title": "Appointments and childcare",
          "summary": "Your reminders for dates already arranged.",
          "tasks": [
            {
              "id": "appointment",
              "title": "Health appointment",
              "source": "care",
              "hint": "Use the confirmed date from your practitioner; no care schedule is inferred.",
              "optional": true
            },
            {
              "id": "place",
              "title": "Respond to a childcare place offer",
              "source": "provider",
              "hint": "Use the acceptance deadline in the offer.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AU",
      "sources": [
        [
          "NSW birth registration",
          "https://www.nsw.gov.au/family-and-relationships/births/register-a-birth"
        ]
      ],
      "count": 9,
      "variant": "default"
    },
    {
      "id": "vehicle-buy",
      "title": "Buying a vehicle",
      "summary": "The cover, paperwork and payments around taking ownership.",
      "sections": [
        {
          "id": "before",
          "title": "Before collection",
          "summary": "Choose the dates that apply to your purchase.",
          "tasks": [
            {
              "id": "payment",
              "title": "Pay the agreed vehicle balance",
              "source": "provider",
              "hint": "Use your purchase agreement; skip if already paid.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange insurance before using the vehicle",
              "source": "plan",
              "hint": "Confirm the required cover and start date for your circumstances.",
              "optional": false
            },
            {
              "id": "collection",
              "title": "Vehicle collection",
              "source": "appointment",
              "hint": "Use the appointment agreed with the seller.",
              "optional": false
            }
          ]
        },
        {
          "id": "collection",
          "title": "Ownership and registration",
          "summary": "Your part of the process, separate from the seller's.",
          "tasks": [
            {
              "id": "complete-transfer",
              "title": "Complete your ownership-transfer step",
              "source": "provider",
              "hint": "Use the authority's process and actual deadline for your purchase.",
              "optional": false
            },
            {
              "id": "registration",
              "title": "Complete vehicle registration if required",
              "source": "provider",
              "hint": "Skip if completed through your ownership transfer or by the seller.",
              "optional": true
            },
            {
              "id": "parking",
              "title": "Update your resident parking permit",
              "source": "plan",
              "hint": "If you have a permit tied to the old vehicle.",
              "optional": true
            },
            {
              "id": "toll",
              "title": "Update your toll account with the new vehicle",
              "source": "plan",
              "hint": "Only if you use an account that needs changing.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AU",
      "sources": [
        ["NSW vehicle purchase", "https://www.service.nsw.gov.au/guide/buying-a-vehicle"]
      ],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "job",
      "title": "Changing jobs",
      "summary": "Leave dates, final claims and paperwork for your new employer.",
      "sections": [
        {
          "id": "previous",
          "title": "Leaving your job",
          "summary": "Deadlines that can be missed during a handover.",
          "tasks": [
            {
              "id": "notice",
              "title": "Submit your resignation or leaving paperwork",
              "source": "provider",
              "hint": "Use your agreed notice arrangements.",
              "optional": true
            },
            {
              "id": "return",
              "title": "Return employer equipment or passes",
              "source": "provider",
              "hint": "Use the return deadline agreed with your employer.",
              "optional": true
            },
            {
              "id": "expenses",
              "title": "Submit outstanding expense claims",
              "source": "provider",
              "hint": "Use your employer's cutoff date.",
              "optional": true
            }
          ]
        },
        {
          "id": "before",
          "title": "Starting your new job",
          "summary": "Only the forms and choices your employer has requested.",
          "tasks": [
            {
              "id": "forms",
              "title": "Submit your new-starter forms",
              "source": "provider",
              "hint": "Use the date supplied by your employer.",
              "optional": false
            },
            {
              "id": "benefits",
              "title": "Submit your employee-benefit choices",
              "source": "provider",
              "hint": "If an enrolment or selection deadline applies.",
              "optional": true
            },
            {
              "id": "payroll",
              "title": "Submit requested tax and superannuation details",
              "source": "provider",
              "hint": "Use your employer's onboarding deadline. Keep financial details outside this app.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AU",
      "sources": [
        [
          "Starting a job",
          "https://my.gov.au/en/services/work/starting-a-job/what-your-employer-needs-from-you/providing-financial-details-to-your-employer"
        ]
      ],
      "count": 6,
      "variant": "default"
    },
    {
      "id": "study",
      "title": "Starting university or college",
      "summary": "Offer, funding and accommodation deadlines for your next course.",
      "sections": [
        {
          "id": "place",
          "title": "Your place and funding",
          "summary": "Use the dates in your offer and funding information.",
          "tasks": [
            {
              "id": "offer",
              "title": "Accept your course offer",
              "source": "provider",
              "hint": "Use the response deadline in the offer.",
              "optional": false
            },
            {
              "id": "enrol",
              "title": "Complete enrolment",
              "source": "provider",
              "hint": "Use the institution's enrolment deadline.",
              "optional": false
            },
            {
              "id": "deposit",
              "title": "Pay the course deposit",
              "source": "provider",
              "hint": "Only if required by your offer.",
              "optional": true
            },
            {
              "id": "funding",
              "title": "Submit your student-funding application",
              "source": "provider",
              "hint": "Only for the scheme you have chosen and are eligible to apply for.",
              "optional": true
            }
          ]
        },
        {
          "id": "accommodation",
          "title": "Accommodation",
          "summary": "If you are taking a place away from home.",
          "tasks": [
            {
              "id": "offer-home",
              "title": "Accept your accommodation offer",
              "source": "provider",
              "hint": "Use the response deadline.",
              "optional": true
            },
            {
              "id": "deposit-home",
              "title": "Pay the accommodation deposit",
              "source": "provider",
              "hint": "Only if required and not included in another payment.",
              "optional": true
            },
            {
              "id": "keys",
              "title": "Accommodation key collection",
              "source": "appointment",
              "hint": "Use your agreed arrival appointment.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AU",
      "sources": [],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "school",
      "title": "Applying for school or childcare",
      "summary": "Application, acceptance and payment dates for a place you are choosing.",
      "sections": [
        {
          "id": "place",
          "title": "Application and offer",
          "summary": "Your arrangements; no child profile is needed.",
          "tasks": [
            {
              "id": "apply",
              "title": "Submit the school or childcare application",
              "source": "provider",
              "hint": "Use the relevant authority or provider's application deadline.",
              "optional": false
            },
            {
              "id": "offer",
              "title": "Respond to the place offer",
              "source": "provider",
              "hint": "Use the deadline stated in the offer.",
              "optional": false
            },
            {
              "id": "forms",
              "title": "Return the requested enrolment forms",
              "source": "provider",
              "hint": "Only the forms requested for the accepted place.",
              "optional": true
            }
          ]
        },
        {
          "id": "start",
          "title": "Before the place starts",
          "summary": "Use the provider's confirmed dates.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Pay the place deposit",
              "source": "provider",
              "hint": "Only if required; skip if already paid.",
              "optional": true
            },
            {
              "id": "induction",
              "title": "Settling-in or induction appointment",
              "source": "appointment",
              "hint": "Only if you have a confirmed session.",
              "optional": true
            },
            {
              "id": "fees",
              "title": "Pay the first fee instalment",
              "source": "provider",
              "hint": "If fees apply and payment is not already automatic.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AU",
      "sources": [],
      "count": 6,
      "variant": "default"
    },
    {
      "id": "marriage",
      "title": "Wedding deadlines and paperwork",
      "summary": "Registration appointments, supplier payments and return dates.",
      "sections": [
        {
          "id": "arrangements",
          "title": "Legal arrangements",
          "summary": "Follow the process for your chosen ceremony or registration.",
          "tasks": [
            {
              "id": "appointment",
              "title": "Notice or registration appointment",
              "source": "appointment",
              "hint": "Only if required by your local process; use the confirmed appointment.",
              "optional": true
            },
            {
              "id": "documents",
              "title": "Submit the documents requested for registration",
              "source": "provider",
              "hint": "Use the authority's actual deadline. No documents are uploaded here.",
              "optional": true
            }
          ]
        },
        {
          "id": "day",
          "title": "Booking deadlines",
          "summary": "Add a separate reminder for each supplier with a different due date.",
          "tasks": [
            {
              "id": "venue-deposit",
              "title": "Pay the venue or supplier deposit",
              "source": "provider",
              "hint": "Use the date in your booking agreement.",
              "optional": true
            },
            {
              "id": "numbers",
              "title": "Submit final guest numbers",
              "source": "provider",
              "hint": "Only if your venue or caterer has given a deadline.",
              "optional": true
            },
            {
              "id": "balance",
              "title": "Pay a supplier's final balance",
              "source": "provider",
              "hint": "Name the supplier and use their payment deadline.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the wedding",
          "summary": "Returns and paperwork that remain outstanding.",
          "tasks": [
            {
              "id": "returns",
              "title": "Return hired wedding items",
              "source": "provider",
              "hint": "Use the return deadline in your hire agreement.",
              "optional": true
            },
            {
              "id": "certificate",
              "title": "Request the marriage certificate",
              "source": "plan",
              "hint": "Only if your process requires a separate request.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AU",
      "sources": [],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "move",
      "title": "Moving home",
      "summary": "Notice dates, services, address changes and getting your deposit back.",
      "sections": [
        {
          "id": "before",
          "title": "Before the move",
          "summary": "Choose the arrangements with a date you need to remember.",
          "tasks": [
            {
              "id": "notice",
              "title": "Give notice on your current tenancy",
              "source": "provider",
              "hint": "Only if you rent. Use your agreement and the rules that apply to your tenancy.",
              "optional": true
            },
            {
              "id": "removals",
              "title": "Removals or van booking",
              "source": "appointment",
              "hint": "Use your confirmed booking date.",
              "optional": true
            },
            {
              "id": "redirect",
              "title": "Submit your USPS change of address",
              "source": "plan",
              "hint": "Use the official USPS process for your move.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange home insurance for the new address",
              "source": "plan",
              "hint": "If needed, arrange cover before the start date agreed with your insurer.",
              "optional": true
            }
          ]
        },
        {
          "id": "leave",
          "title": "Leaving your old home",
          "summary": "Close accounts and keep the readings needed for your final bills.",
          "tasks": [
            {
              "id": "old-energy",
              "title": "Notify your old energy supplier",
              "source": "plan",
              "hint": "Give your move-out date using your supplier's process.",
              "optional": true
            },
            {
              "id": "old-water",
              "title": "Notify your old water supplier",
              "source": "plan",
              "hint": "If you hold a separate water account.",
              "optional": true
            },
            {
              "id": "old-internet",
              "title": "Arrange your internet transfer or cancellation",
              "source": "plan",
              "hint": "Allow for your provider's notice period. Choose the arrangement you actually need.",
              "optional": true
            },
            {
              "id": "final-energy",
              "title": "Record final energy meter readings",
              "source": "plan",
              "hint": "Choose your handover date. Keep the readings outside this app.",
              "optional": true
            },
            {
              "id": "final-water",
              "title": "Record the final water meter reading",
              "source": "plan",
              "hint": "Only if your property has a water meter you need to read.",
              "optional": true
            }
          ]
        },
        {
          "id": "arrive",
          "title": "At your new home",
          "summary": "Your handover and service arrangements.",
          "tasks": [
            {
              "id": "keys",
              "title": "New-home key handover",
              "source": "appointment",
              "hint": "Use the agreed handover date.",
              "optional": false
            },
            {
              "id": "new-energy",
              "title": "Set up the new energy account",
              "source": "plan",
              "hint": "If you are responsible for the supply.",
              "optional": true
            },
            {
              "id": "new-water",
              "title": "Set up the new water account",
              "source": "plan",
              "hint": "If a separate account is needed.",
              "optional": true
            },
            {
              "id": "new-internet",
              "title": "Internet installation appointment",
              "source": "appointment",
              "hint": "Only if an installation visit is booked.",
              "optional": true
            },
            {
              "id": "inventory",
              "title": "Return the checked inventory or condition report",
              "source": "provider",
              "hint": "If required, use the deadline in your handover instructions.",
              "optional": true
            }
          ]
        },
        {
          "id": "details",
          "title": "Update your address",
          "summary": "Choose the organisations you use. Each can have its own reminder.",
          "tasks": [
            {
              "id": "bank",
              "title": "Update your bank address",
              "source": "plan",
              "hint": "Add another reminder if a different bank needs a different date.",
              "optional": true
            },
            {
              "id": "employer",
              "title": "Update your employer's address records",
              "source": "plan",
              "hint": "If you need to update payroll or contact details.",
              "optional": true
            },
            {
              "id": "motor-cover",
              "title": "Update your motor-insurance address",
              "source": "plan",
              "hint": "Check with your insurer when the change needs to take effect.",
              "optional": true
            },
            {
              "id": "school",
              "title": "Update your school or childcare contact address",
              "source": "plan",
              "hint": "Only if relevant to your arrangements.",
              "optional": true
            },
            {
              "id": "pet-details",
              "title": "Update your pet's microchip contact details",
              "source": "plan",
              "hint": "Use the database holding your pet's registration.",
              "optional": true
            },
            {
              "id": "licence",
              "title": "Update your driver licence with the relevant state",
              "source": "provider",
              "hint": "Use your destination state's process if moving interstate.",
              "optional": true
            },
            {
              "id": "vehicle",
              "title": "Update your vehicle title or registration details",
              "source": "provider",
              "hint": "Check which separate steps your state requires.",
              "optional": true
            },
            {
              "id": "voter",
              "title": "Update voter registration if eligible",
              "source": "provider",
              "hint": "Use the applicable state process.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the move",
          "summary": "Outstanding money and equipment with a return deadline.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Follow up your tenancy-deposit return",
              "source": "provider",
              "hint": "Use the expected return date agreed through your tenancy process.",
              "optional": true
            },
            {
              "id": "return-router",
              "title": "Return your old provider's router or equipment",
              "source": "provider",
              "hint": "Use the return deadline from your provider.",
              "optional": true
            }
          ]
        }
      ],
      "market": "US",
      "sources": [["Address changes", "https://www.usa.gov/change-address"]],
      "count": 24,
      "variant": "default"
    },
    {
      "id": "holiday",
      "title": "Going on a booked holiday",
      "summary": "Payment deadlines, travel paperwork and arrangements before you leave.",
      "sections": [
        {
          "id": "essentials",
          "title": "Before you travel",
          "summary": "Use your booking and destination requirements.",
          "tasks": [
            {
              "id": "documents",
              "title": "Check passport validity and entry requirements",
              "source": "plan",
              "hint": "Choose a date early enough to act. Requirements depend on your destination and circumstances.",
              "optional": false
            },
            {
              "id": "document-apply",
              "title": "Submit the visa or travel-authorisation application",
              "source": "provider",
              "hint": "Only if required. Check the relevant authority's current process and processing time.",
              "optional": true
            },
            {
              "id": "balance",
              "title": "Pay the holiday booking balance",
              "source": "provider",
              "hint": "Use the due date in your booking. Skip if already paid.",
              "optional": true
            },
            {
              "id": "insurance",
              "title": "Arrange travel insurance",
              "source": "plan",
              "hint": "If you need cover, check when it needs to begin.",
              "optional": true
            }
          ]
        },
        {
          "id": "departure",
          "title": "Bookings to remember",
          "summary": "Only include bookings or deadlines you actually have.",
          "tasks": [
            {
              "id": "checkin",
              "title": "Complete airline online check-in",
              "source": "provider",
              "hint": "Use your airline's check-in window.",
              "optional": true
            },
            {
              "id": "pet-care",
              "title": "Confirm your pet's boarding or sitter booking",
              "source": "plan",
              "hint": "If your pet is staying behind; use the provider's confirmation deadline if supplied.",
              "optional": true
            },
            {
              "id": "parking",
              "title": "Pay a travel or airport-parking booking balance",
              "source": "provider",
              "hint": "Only if your existing booking has an outstanding payment.",
              "optional": true
            },
            {
              "id": "return-vehicle",
              "title": "Return the hire car",
              "source": "appointment",
              "hint": "Use the return date and time in your rental agreement.",
              "optional": true
            }
          ]
        }
      ],
      "market": "US",
      "sources": [],
      "count": 8,
      "variant": "default"
    },
    {
      "id": "pet",
      "title": "Your pet's care dates",
      "summary": "Vet dates, treatments, insurance and boarding requirements in one place.",
      "sections": [
        {
          "id": "care",
          "title": "Health and appointments",
          "summary": "Use dates already given by your vet or provider.",
          "tasks": [
            {
              "id": "vaccination",
              "title": "Pet vaccination due",
              "source": "care",
              "hint": "Use the next date given by your vet.",
              "optional": false
            },
            {
              "id": "flea",
              "title": "Pet flea treatment due",
              "source": "care",
              "hint": "Use the next treatment date given by your vet.",
              "optional": true
            },
            {
              "id": "worm",
              "title": "Pet worm treatment due",
              "source": "care",
              "hint": "Use the next treatment date given by your vet.",
              "optional": true
            },
            {
              "id": "medicine",
              "title": "Collect your pet's prescribed medicine",
              "source": "care",
              "hint": "Use the collection or refill date agreed with your vet.",
              "optional": true
            },
            {
              "id": "groom",
              "title": "Pet grooming appointment",
              "source": "appointment",
              "hint": "Use your confirmed booking.",
              "optional": true
            }
          ]
        },
        {
          "id": "records",
          "title": "Insurance and records",
          "summary": "Choose only the records that need attention.",
          "tasks": [
            {
              "id": "insurance",
              "title": "Pet-insurance renewal",
              "source": "provider",
              "hint": "Use the renewal date on your policy.",
              "optional": true
            },
            {
              "id": "chip-update",
              "title": "Update your pet's microchip details",
              "source": "plan",
              "hint": "Useful after a move, new phone number or change of keeper.",
              "optional": true
            },
            {
              "id": "registration-apply",
              "title": "Register or license your pet if required",
              "source": "provider",
              "hint": "Check your local authority's requirements and the term of any licence issued.",
              "optional": true
            },
            {
              "id": "licence-renew",
              "title": "Renew an expiring pet licence",
              "source": "provider",
              "hint": "Only if your actual licence expires; skip lifetime registration.",
              "optional": true
            }
          ]
        },
        {
          "id": "away",
          "title": "Before boarding",
          "summary": "Requirements tied to a stay you have booked.",
          "tasks": [
            {
              "id": "requirements",
              "title": "Send the boarding provider's required records",
              "source": "provider",
              "hint": "Use their deadline and send records directly to the provider; there are no uploads here.",
              "optional": true
            },
            {
              "id": "boarding",
              "title": "Pet boarding drop-off",
              "source": "appointment",
              "hint": "Use the booking you have made.",
              "optional": true
            },
            {
              "id": "collect",
              "title": "Pet boarding collection",
              "source": "appointment",
              "hint": "Use the agreed collection date.",
              "optional": true
            }
          ]
        }
      ],
      "market": "US",
      "sources": [
        ["NYC dog-licence example", "https://www.nyc.gov/site/doh/services/dog-licenses.page"]
      ],
      "count": 12,
      "variant": "default"
    },
    {
      "id": "baby",
      "title": "New-baby paperwork and appointments",
      "summary": "Registration, parental leave, support applications and booked appointments.",
      "sections": [
        {
          "id": "leave",
          "title": "Leave and support",
          "summary": "Your own requests and applications, where applicable.",
          "tasks": [
            {
              "id": "leave-request",
              "title": "Submit your parental-leave request",
              "source": "provider",
              "hint": "Use your employer's process and the dates that apply to you.",
              "optional": true
            },
            {
              "id": "support-apply",
              "title": "Submit a family-benefit or support application",
              "source": "provider",
              "hint": "Only after checking eligibility and the actual application deadline.",
              "optional": true
            },
            {
              "id": "return-work",
              "title": "Confirm your return-to-work date",
              "source": "provider",
              "hint": "Use the notice arrangements agreed with your employer.",
              "optional": true
            }
          ]
        },
        {
          "id": "paperwork",
          "title": "Registration and cover",
          "summary": "Follow the process that applies where the birth is registered.",
          "tasks": [
            {
              "id": "register",
              "title": "Complete the applicable birth-registration step",
              "source": "provider",
              "hint": "Confirm what the hospital submits and what you need to request from state or local vital records.",
              "optional": false
            },
            {
              "id": "certificate",
              "title": "Order a birth certificate if needed",
              "source": "plan",
              "hint": "Only if a separate request is needed. No certificate details or uploads are stored here.",
              "optional": true
            },
            {
              "id": "health-registration",
              "title": "Complete health-service or health-cover enrolment",
              "source": "provider",
              "hint": "If needed, use your health service or insurer's actual enrolment deadline.",
              "optional": true
            },
            {
              "id": "passport",
              "title": "Submit a passport application for planned travel",
              "source": "plan",
              "hint": "Only if needed for travel. Check the issuing authority's process.",
              "optional": true
            }
          ]
        },
        {
          "id": "appointments",
          "title": "Appointments and childcare",
          "summary": "Your reminders for dates already arranged.",
          "tasks": [
            {
              "id": "appointment",
              "title": "Health appointment",
              "source": "care",
              "hint": "Use the confirmed date from your practitioner; no care schedule is inferred.",
              "optional": true
            },
            {
              "id": "place",
              "title": "Respond to a childcare place offer",
              "source": "provider",
              "hint": "Use the acceptance deadline in the offer.",
              "optional": true
            }
          ]
        }
      ],
      "market": "US",
      "sources": [["Birth certificates", "https://www.usa.gov/birth-certificate"]],
      "count": 9,
      "variant": "default"
    },
    {
      "id": "vehicle-buy",
      "title": "Buying a vehicle",
      "summary": "The cover, paperwork and payments around taking ownership.",
      "sections": [
        {
          "id": "before",
          "title": "Before collection",
          "summary": "Choose the dates that apply to your purchase.",
          "tasks": [
            {
              "id": "payment",
              "title": "Pay the agreed vehicle balance",
              "source": "provider",
              "hint": "Use your purchase agreement; skip if already paid.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange insurance before using the vehicle",
              "source": "plan",
              "hint": "Confirm the required cover and start date for your circumstances.",
              "optional": false
            },
            {
              "id": "collection",
              "title": "Vehicle collection",
              "source": "appointment",
              "hint": "Use the appointment agreed with the seller.",
              "optional": false
            }
          ]
        },
        {
          "id": "collection",
          "title": "Ownership and registration",
          "summary": "Your part of the process, separate from the seller's.",
          "tasks": [
            {
              "id": "complete-transfer",
              "title": "Complete your ownership-transfer step",
              "source": "provider",
              "hint": "Use the authority's process and actual deadline for your purchase.",
              "optional": false
            },
            {
              "id": "registration",
              "title": "Complete vehicle registration if required",
              "source": "provider",
              "hint": "Skip if completed through your ownership transfer or by the seller.",
              "optional": true
            },
            {
              "id": "parking",
              "title": "Update your resident parking permit",
              "source": "plan",
              "hint": "If you have a permit tied to the old vehicle.",
              "optional": true
            },
            {
              "id": "toll",
              "title": "Update your toll account with the new vehicle",
              "source": "plan",
              "hint": "Only if you use an account that needs changing.",
              "optional": true
            }
          ]
        }
      ],
      "market": "US",
      "sources": [["State vehicle services", "https://www.usa.gov/state-motor-vehicle-services"]],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "job",
      "title": "Changing jobs",
      "summary": "Leave dates, final claims and paperwork for your new employer.",
      "sections": [
        {
          "id": "previous",
          "title": "Leaving your job",
          "summary": "Deadlines that can be missed during a handover.",
          "tasks": [
            {
              "id": "notice",
              "title": "Submit your resignation or leaving paperwork",
              "source": "provider",
              "hint": "Use your agreed notice arrangements.",
              "optional": true
            },
            {
              "id": "return",
              "title": "Return employer equipment or passes",
              "source": "provider",
              "hint": "Use the return deadline agreed with your employer.",
              "optional": true
            },
            {
              "id": "expenses",
              "title": "Submit outstanding expense claims",
              "source": "provider",
              "hint": "Use your employer's cutoff date.",
              "optional": true
            }
          ]
        },
        {
          "id": "before",
          "title": "Starting your new job",
          "summary": "Only the forms and choices your employer has requested.",
          "tasks": [
            {
              "id": "forms",
              "title": "Submit your new-starter forms",
              "source": "provider",
              "hint": "Use the date supplied by your employer.",
              "optional": false
            },
            {
              "id": "coverage-choice",
              "title": "Submit your health-cover enrolment choice",
              "source": "provider",
              "hint": "If applicable, use the actual enrolment deadline; eligibility is not assumed.",
              "optional": true
            }
          ]
        }
      ],
      "market": "US",
      "sources": [
        [
          "Job-based cover changes",
          "https://www.healthcare.gov/have-job-based-coverage/if-you-lose-job-based-coverage/index.html"
        ]
      ],
      "count": 5,
      "variant": "default"
    },
    {
      "id": "study",
      "title": "Starting university or college",
      "summary": "Offer, funding and accommodation deadlines for your next course.",
      "sections": [
        {
          "id": "place",
          "title": "Your place and funding",
          "summary": "Use the dates in your offer and funding information.",
          "tasks": [
            {
              "id": "offer",
              "title": "Accept your course offer",
              "source": "provider",
              "hint": "Use the response deadline in the offer.",
              "optional": false
            },
            {
              "id": "enrol",
              "title": "Complete enrolment",
              "source": "provider",
              "hint": "Use the institution's enrolment deadline.",
              "optional": false
            },
            {
              "id": "deposit",
              "title": "Pay the course deposit",
              "source": "provider",
              "hint": "Only if required by your offer.",
              "optional": true
            },
            {
              "id": "funding",
              "title": "Submit your student-funding application",
              "source": "provider",
              "hint": "Only for the scheme you have chosen and are eligible to apply for.",
              "optional": true
            }
          ]
        },
        {
          "id": "accommodation",
          "title": "Accommodation",
          "summary": "If you are taking a place away from home.",
          "tasks": [
            {
              "id": "offer-home",
              "title": "Accept your accommodation offer",
              "source": "provider",
              "hint": "Use the response deadline.",
              "optional": true
            },
            {
              "id": "deposit-home",
              "title": "Pay the accommodation deposit",
              "source": "provider",
              "hint": "Only if required and not included in another payment.",
              "optional": true
            },
            {
              "id": "keys",
              "title": "Accommodation key collection",
              "source": "appointment",
              "hint": "Use your agreed arrival appointment.",
              "optional": true
            }
          ]
        }
      ],
      "market": "US",
      "sources": [],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "school",
      "title": "Applying for school or childcare",
      "summary": "Application, acceptance and payment dates for a place you are choosing.",
      "sections": [
        {
          "id": "place",
          "title": "Application and offer",
          "summary": "Your arrangements; no child profile is needed.",
          "tasks": [
            {
              "id": "apply",
              "title": "Submit the school or childcare application",
              "source": "provider",
              "hint": "Use the relevant authority or provider's application deadline.",
              "optional": false
            },
            {
              "id": "offer",
              "title": "Respond to the place offer",
              "source": "provider",
              "hint": "Use the deadline stated in the offer.",
              "optional": false
            },
            {
              "id": "forms",
              "title": "Return the requested enrolment forms",
              "source": "provider",
              "hint": "Only the forms requested for the accepted place.",
              "optional": true
            }
          ]
        },
        {
          "id": "start",
          "title": "Before the place starts",
          "summary": "Use the provider's confirmed dates.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Pay the place deposit",
              "source": "provider",
              "hint": "Only if required; skip if already paid.",
              "optional": true
            },
            {
              "id": "induction",
              "title": "Settling-in or induction appointment",
              "source": "appointment",
              "hint": "Only if you have a confirmed session.",
              "optional": true
            },
            {
              "id": "fees",
              "title": "Pay the first fee instalment",
              "source": "provider",
              "hint": "If fees apply and payment is not already automatic.",
              "optional": true
            }
          ]
        }
      ],
      "market": "US",
      "sources": [],
      "count": 6,
      "variant": "default"
    },
    {
      "id": "marriage",
      "title": "Wedding deadlines and paperwork",
      "summary": "Registration appointments, supplier payments and return dates.",
      "sections": [
        {
          "id": "arrangements",
          "title": "Legal arrangements",
          "summary": "Follow the process for your chosen ceremony or registration.",
          "tasks": [
            {
              "id": "appointment",
              "title": "Notice or registration appointment",
              "source": "appointment",
              "hint": "Only if required by your local process; use the confirmed appointment.",
              "optional": true
            },
            {
              "id": "documents",
              "title": "Submit the documents requested for registration",
              "source": "provider",
              "hint": "Use the authority's actual deadline. No documents are uploaded here.",
              "optional": true
            }
          ]
        },
        {
          "id": "day",
          "title": "Booking deadlines",
          "summary": "Add a separate reminder for each supplier with a different due date.",
          "tasks": [
            {
              "id": "venue-deposit",
              "title": "Pay the venue or supplier deposit",
              "source": "provider",
              "hint": "Use the date in your booking agreement.",
              "optional": true
            },
            {
              "id": "numbers",
              "title": "Submit final guest numbers",
              "source": "provider",
              "hint": "Only if your venue or caterer has given a deadline.",
              "optional": true
            },
            {
              "id": "balance",
              "title": "Pay a supplier's final balance",
              "source": "provider",
              "hint": "Name the supplier and use their payment deadline.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the wedding",
          "summary": "Returns and paperwork that remain outstanding.",
          "tasks": [
            {
              "id": "returns",
              "title": "Return hired wedding items",
              "source": "provider",
              "hint": "Use the return deadline in your hire agreement.",
              "optional": true
            },
            {
              "id": "certificate",
              "title": "Request the marriage certificate",
              "source": "plan",
              "hint": "Only if your process requires a separate request.",
              "optional": true
            }
          ]
        }
      ],
      "market": "US",
      "sources": [],
      "count": 7,
      "variant": "default"
    },
    {
      "id": "move",
      "title": "Moving home",
      "summary": "Notice dates, services, address changes and getting your deposit back.",
      "sections": [
        {
          "id": "before",
          "title": "Before the move",
          "summary": "Choose the arrangements with a date you need to remember.",
          "tasks": [
            {
              "id": "notice",
              "title": "Give notice on your current tenancy",
              "source": "provider",
              "hint": "Only if you rent. Use your agreement and the rules that apply to your tenancy.",
              "optional": true
            },
            {
              "id": "removals",
              "title": "Removals or van booking",
              "source": "appointment",
              "hint": "Use your confirmed booking date.",
              "optional": true
            },
            {
              "id": "redirect",
              "title": "Arrange mail redirection",
              "source": "plan",
              "hint": "Choose when to apply, allowing for the postal service's lead time.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange home insurance for the new address",
              "source": "plan",
              "hint": "If needed, arrange cover before the start date agreed with your insurer.",
              "optional": true
            }
          ]
        },
        {
          "id": "leave",
          "title": "Leaving your old home",
          "summary": "Close accounts and keep the readings needed for your final bills.",
          "tasks": [
            {
              "id": "old-energy",
              "title": "Notify your old energy supplier",
              "source": "plan",
              "hint": "Give your move-out date using your supplier's process.",
              "optional": true
            },
            {
              "id": "old-water",
              "title": "Notify your old water supplier",
              "source": "plan",
              "hint": "If you hold a separate water account.",
              "optional": true
            },
            {
              "id": "old-internet",
              "title": "Arrange your internet transfer or cancellation",
              "source": "plan",
              "hint": "Allow for your provider's notice period. Choose the arrangement you actually need.",
              "optional": true
            },
            {
              "id": "final-energy",
              "title": "Record final energy meter readings",
              "source": "plan",
              "hint": "Choose your handover date. Keep the readings outside this app.",
              "optional": true
            },
            {
              "id": "final-water",
              "title": "Record the final water meter reading",
              "source": "plan",
              "hint": "Only if your property has a water meter you need to read.",
              "optional": true
            }
          ]
        },
        {
          "id": "arrive",
          "title": "At your new home",
          "summary": "Your handover and service arrangements.",
          "tasks": [
            {
              "id": "new-energy",
              "title": "Set up the new energy account",
              "source": "plan",
              "hint": "If you are responsible for the supply.",
              "optional": true
            },
            {
              "id": "new-water",
              "title": "Set up the new water account",
              "source": "plan",
              "hint": "If a separate account is needed.",
              "optional": true
            },
            {
              "id": "new-internet",
              "title": "Internet installation appointment",
              "source": "appointment",
              "hint": "Only if an installation visit is booked.",
              "optional": true
            }
          ]
        },
        {
          "id": "details",
          "title": "Update your address",
          "summary": "Choose the organisations you use. Each can have its own reminder.",
          "tasks": [
            {
              "id": "bank",
              "title": "Update your bank address",
              "source": "plan",
              "hint": "Add another reminder if a different bank needs a different date.",
              "optional": true
            },
            {
              "id": "employer",
              "title": "Update your employer's address records",
              "source": "plan",
              "hint": "If you need to update payroll or contact details.",
              "optional": true
            },
            {
              "id": "motor-cover",
              "title": "Update your motor-insurance address",
              "source": "plan",
              "hint": "Check with your insurer when the change needs to take effect.",
              "optional": true
            },
            {
              "id": "school",
              "title": "Update your school or childcare contact address",
              "source": "plan",
              "hint": "Only if relevant to your arrangements.",
              "optional": true
            },
            {
              "id": "pet-details",
              "title": "Update your pet's microchip contact details",
              "source": "plan",
              "hint": "Use the database holding your pet's registration.",
              "optional": true
            },
            {
              "id": "official-address",
              "title": "Update your address with the relevant authority",
              "source": "provider",
              "hint": "Use ICA or MOM's route as applicable to your citizen, permanent-resident or pass status.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the move",
          "summary": "Outstanding money and equipment with a return deadline.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Follow up your tenancy-deposit return",
              "source": "provider",
              "hint": "Use the expected return date agreed through your tenancy process.",
              "optional": true
            },
            {
              "id": "return-router",
              "title": "Return your old provider's router or equipment",
              "source": "provider",
              "hint": "Use the return deadline from your provider.",
              "optional": true
            }
          ]
        },
        {
          "id": "hdb",
          "title": "Your HDB handover",
          "summary": "Only if this is the handover process you are using.",
          "tasks": [
            {
              "id": "hdb-keys",
              "title": "HDB key-collection appointment",
              "source": "appointment",
              "hint": "Use your appointment notice.",
              "optional": false
            },
            {
              "id": "hdb-inspect",
              "title": "Submit your flat's defect report",
              "source": "provider",
              "hint": "If needed, use the applicable HDB handover instructions.",
              "optional": true
            }
          ]
        }
      ],
      "market": "SG",
      "sources": [
        ["Address routes", "https://ask.gov.sg/singpass/questions/clul08v6p001mufi2ju0z5b09"],
        [
          "New HDB flat",
          "https://www.hdb.gov.sg/managing-my-home/home-ownership/checklist-for-moving-into-flat"
        ]
      ],
      "count": 22,
      "variant": "hdb"
    },
    {
      "id": "move",
      "title": "Moving home",
      "summary": "Notice dates, services, address changes and getting your deposit back.",
      "sections": [
        {
          "id": "before",
          "title": "Before the move",
          "summary": "Choose the arrangements with a date you need to remember.",
          "tasks": [
            {
              "id": "notice",
              "title": "Give notice on your current tenancy",
              "source": "provider",
              "hint": "Only if you rent. Use your agreement and the rules that apply to your tenancy.",
              "optional": true
            },
            {
              "id": "removals",
              "title": "Removals or van booking",
              "source": "appointment",
              "hint": "Use your confirmed booking date.",
              "optional": true
            },
            {
              "id": "redirect",
              "title": "Arrange mail redirection",
              "source": "plan",
              "hint": "Choose when to apply, allowing for the postal service's lead time.",
              "optional": true
            },
            {
              "id": "cover",
              "title": "Arrange home insurance for the new address",
              "source": "plan",
              "hint": "If needed, arrange cover before the start date agreed with your insurer.",
              "optional": true
            }
          ]
        },
        {
          "id": "leave",
          "title": "Leaving your old home",
          "summary": "Close accounts and keep the readings needed for your final bills.",
          "tasks": [
            {
              "id": "old-energy",
              "title": "Notify your old energy supplier",
              "source": "plan",
              "hint": "Give your move-out date using your supplier's process.",
              "optional": true
            },
            {
              "id": "old-water",
              "title": "Notify your old water supplier",
              "source": "plan",
              "hint": "If you hold a separate water account.",
              "optional": true
            },
            {
              "id": "old-internet",
              "title": "Arrange your internet transfer or cancellation",
              "source": "plan",
              "hint": "Allow for your provider's notice period. Choose the arrangement you actually need.",
              "optional": true
            },
            {
              "id": "final-energy",
              "title": "Record final energy meter readings",
              "source": "plan",
              "hint": "Choose your handover date. Keep the readings outside this app.",
              "optional": true
            },
            {
              "id": "final-water",
              "title": "Record the final water meter reading",
              "source": "plan",
              "hint": "Only if your property has a water meter you need to read.",
              "optional": true
            }
          ]
        },
        {
          "id": "arrive",
          "title": "At your new home",
          "summary": "Your handover and service arrangements.",
          "tasks": [
            {
              "id": "keys",
              "title": "New-home key handover",
              "source": "appointment",
              "hint": "Use the agreed handover date.",
              "optional": false
            },
            {
              "id": "new-internet",
              "title": "Internet installation appointment",
              "source": "appointment",
              "hint": "Only if an installation visit is booked.",
              "optional": true
            },
            {
              "id": "inventory",
              "title": "Return the checked inventory or condition report",
              "source": "provider",
              "hint": "If required, use the deadline in your handover instructions.",
              "optional": true
            },
            {
              "id": "dewa",
              "title": "Arrange your DEWA move-to request",
              "source": "plan",
              "hint": "For an existing account transfer between homes in Dubai; use DEWA's process.",
              "optional": true
            }
          ]
        },
        {
          "id": "details",
          "title": "Update your address",
          "summary": "Choose the organisations you use. Each can have its own reminder.",
          "tasks": [
            {
              "id": "bank",
              "title": "Update your bank address",
              "source": "plan",
              "hint": "Add another reminder if a different bank needs a different date.",
              "optional": true
            },
            {
              "id": "employer",
              "title": "Update your employer's address records",
              "source": "plan",
              "hint": "If you need to update payroll or contact details.",
              "optional": true
            },
            {
              "id": "motor-cover",
              "title": "Update your motor-insurance address",
              "source": "plan",
              "hint": "Check with your insurer when the change needs to take effect.",
              "optional": true
            },
            {
              "id": "school",
              "title": "Update your school or childcare contact address",
              "source": "plan",
              "hint": "Only if relevant to your arrangements.",
              "optional": true
            },
            {
              "id": "pet-details",
              "title": "Update your pet's microchip contact details",
              "source": "plan",
              "hint": "Use the database holding your pet's registration.",
              "optional": true
            },
            {
              "id": "tenancy",
              "title": "Confirm your emirate's tenancy-registration steps",
              "source": "provider",
              "hint": "Dubai's Ejari process must not be assumed to apply in another emirate.",
              "optional": true
            },
            {
              "id": "official-address",
              "title": "Check which official address records need changing",
              "source": "provider",
              "hint": "Use the authority for your own residency and emirate.",
              "optional": true
            }
          ]
        },
        {
          "id": "after",
          "title": "After the move",
          "summary": "Outstanding money and equipment with a return deadline.",
          "tasks": [
            {
              "id": "deposit",
              "title": "Follow up your tenancy-deposit return",
              "source": "provider",
              "hint": "Use the expected return date agreed through your tenancy process.",
              "optional": true
            },
            {
              "id": "return-router",
              "title": "Return your old provider's router or equipment",
              "source": "provider",
              "hint": "Use the return deadline from your provider.",
              "optional": true
            }
          ]
        }
      ],
      "market": "AE",
      "sources": [
        [
          "Dubai utility transfer",
          "https://dewa.gov.ae/en/consumer/supply-management/transfer-of-electricity-water-move-to"
        ]
      ],
      "count": 22,
      "variant": "dewa"
    }
  ]
}
